// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ================================================================
   Collaboration Requests — full design system
   Colours & spacing aligned with Flowchest's existing dashboard
   ================================================================ */
.cr-muted {
  color: var(--fc-fg-muted, #94a3b8);
  font-size: 0.8125rem;
}

.cr-fw6 {
  font-weight: 600;
  font-size: 0.9rem;
}

.material-symbols-outlined {
  font-family: "Material Symbols Outlined", sans-serif !important;
  font-weight: normal !important;
  font-style: normal !important;
  line-height: 1 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  display: inline-block !important;
  white-space: nowrap !important;
  -webkit-font-smoothing: antialiased;
  vertical-align: middle;
}

.cr-page {
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  color: var(--fc-fg, #0f172a);
  padding: 1.5rem 1.75rem 5rem;
  min-height: calc(100vh - 64px);
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
}
@media (max-width: 767px) {
  .cr-page {
    padding: 1rem 1rem 4rem;
  }
}

.cr-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.cr-header-left {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.cr-header-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 0.625rem;
  background: rgba(94, 161, 216, 0.15);
  color: #5ea1d8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cr-header-icon .material-symbols-outlined {
  font-size: 1.5rem !important;
}

.cr-title {
  font-size: 1.75rem;
  font-weight: 800;
  margin: 0 0 0.2rem;
  font-family: "Manrope", system-ui, sans-serif;
}

.cr-subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: var(--fc-fg-muted, #94a3b8);
}

.cr-tabs {
  display: flex;
  gap: 0.5rem;
  border-bottom: 2px solid var(--fc-border, #e2e8f0);
  margin-bottom: 1.5rem;
}

.cr-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.75rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--fc-fg-muted, #94a3b8);
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}
.cr-tab .material-symbols-outlined {
  font-size: 1.125rem !important;
}
.cr-tab:hover {
  color: #5ea1d8;
}
.cr-tab--active {
  color: #5ea1d8;
  border-bottom-color: #5ea1d8;
}

.cr-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  background: #5ea1d8;
  color: #fff;
  line-height: 1;
}
.cr-tab-badge--neutral {
  background: #9e9e9e;
}

.cr-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}
@media (min-width: 640px) {
  .cr-stats {
    grid-template-columns: repeat(4, 1fr);
  }
}

.cr-stat-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: var(--fc-bg, #ffffff);
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--fc-border, #e2e8f0);
}

:host-context(body.theme-dark) .cr-stat-card {
  background: #111827 !important;
  background-color: #111827 !important;
  border-color: rgba(148, 163, 184, 0.22) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-stat-value {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .cr-stat-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .cr-stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
:host-context(body.theme-dark) .cr-stat-icon--primary {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #7bbde8 !important;
}
:host-context(body.theme-dark) .cr-stat-icon--pending {
  background: rgba(253, 186, 116, 0.16) !important;
  color: #fde68a !important;
}
:host-context(body.theme-dark) .cr-stat-icon--approved {
  background: rgba(134, 239, 172, 0.14) !important;
  color: #86efac !important;
}
:host-context(body.theme-dark) .cr-stat-icon--rejected {
  background: rgba(252, 165, 165, 0.14) !important;
  color: #fca5a5 !important;
}

.cr-stat-icon {
  font-size: 1.625rem !important;
  flex-shrink: 0;
}
.cr-stat-icon--primary {
  color: #5ea1d8;
}
.cr-stat-icon--pending {
  color: #d97706;
}
.cr-stat-icon--approved {
  color: #16a34a;
}
.cr-stat-icon--rejected {
  color: #dc2626;
}

.cr-stat-value {
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1;
  font-family: "Manrope", system-ui, sans-serif;
}

.cr-stat-label {
  font-size: 0.8125rem;
  color: var(--fc-fg-muted, #94a3b8);
  margin-top: 2px;
}

.cr-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.cr-search-wrap {
  position: relative;
  flex: 1;
  min-width: 220px;
}

.cr-search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--fc-fg-muted, #94a3b8);
  font-size: 1.125rem !important;
  pointer-events: none;
}

.cr-search {
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 0 0.875rem 0 2.5rem;
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  background: var(--fc-bg, #ffffff);
  color: var(--fc-fg, #0f172a);
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.cr-search:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
}

.cr-filter-select {
  padding: 0 0.875rem;
  margin: 0;
  box-sizing: border-box;
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  background: var(--fc-bg, #ffffff);
  color: var(--fc-fg, #0f172a);
  cursor: pointer;
  height: 40px;
}
.cr-filter-select:focus {
  outline: none;
  border-color: #5ea1d8;
}

.cr-view-toggle {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 0.5rem;
  background: var(--fc-bg, #ffffff);
  color: var(--fc-fg-muted, #94a3b8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.cr-view-toggle .material-symbols-outlined {
  font-size: 1.125rem !important;
}
.cr-view-toggle:hover {
  background: rgba(94, 161, 216, 0.08);
  color: #5ea1d8;
}

.cr-cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}
@media (min-width: 768px) {
  .cr-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1280px) {
  .cr-cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.cr-card {
  background: var(--fc-bg, #ffffff);
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: box-shadow 0.3s ease, border-color 0.2s ease;
  box-sizing: border-box;
}
.cr-card:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
  border-color: rgba(94, 161, 216, 0.35);
}

.cr-card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 24px 24px 0;
}

.cr-card-who {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cr-card-name {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: var(--fc-fg, #0f172a);
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}

.cr-card-email {
  margin: 0;
  font-size: 12px;
  color: var(--fc-fg-muted, #94a3b8);
}

.cr-card-username {
  font-size: 12px;
  color: #5ea1d8;
}

.cr-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
}

.cr-content-row {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
}

.cr-content-type-icon {
  color: #5ea1d8;
  font-size: 1.25rem !important;
  flex-shrink: 0;
  margin-top: 2px;
}

.cr-content-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cr-content-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--fc-fg-muted, #94a3b8);
}

.cr-content-title {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: none;
  border: none;
  padding: 0;
  font-size: 15px;
  font-weight: 500;
  color: #5ea1d8;
  cursor: pointer;
  text-align: left;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  transition: color 0.15s, -webkit-text-decoration 0.15s;
  transition: color 0.15s, text-decoration 0.15s;
  transition: color 0.15s, text-decoration 0.15s, -webkit-text-decoration 0.15s;
  line-height: 1.5;
}
.cr-content-title .material-symbols-outlined {
  font-size: 0.875rem !important;
}
.cr-content-title:hover {
  color: #4a8fc4;
  text-decoration: underline;
}

.cr-role-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 14px;
  color: var(--fc-fg, #0f172a);
  font-weight: 500;
}
.cr-role-row .material-symbols-outlined {
  color: #5ea1d8;
  font-size: 1rem !important;
}
.cr-role-row strong {
  color: var(--fc-fg, #0f172a);
}

.cr-message, .cr-response {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  background: var(--fc-bg2, #f8f9fa);
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  border-left: 3px solid transparent;
}
.cr-message p, .cr-response p {
  margin: 0;
  line-height: 1.6;
  flex: 1;
  color: var(--fc-fg, #0f172a);
}
.cr-message .material-symbols-outlined, .cr-response .material-symbols-outlined {
  font-size: 1rem !important;
  flex-shrink: 0;
  color: var(--fc-fg-muted, #94a3b8);
  margin-top: 1px;
}

.cr-response {
  border-left-color: #5ea1d8;
}
.cr-response .material-symbols-outlined {
  color: #5ea1d8;
}

.cr-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-top: 0.25rem;
}

.cr-date {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 12px;
  color: var(--fc-fg-muted, #94a3b8);
}
.cr-date .material-symbols-outlined {
  font-size: 0.9rem !important;
}
.cr-date--response {
  color: #16a34a;
}
.cr-date--response .material-symbols-outlined {
  color: #16a34a;
}

.cr-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1px solid var(--fc-border, #e2e8f0);
  background: transparent;
}
.cr-card-actions .cr-btn {
  flex: 1;
  min-width: 0;
  justify-content: center;
}

.cr-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
  color: #fff;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}
.cr-avatar--primary {
  background: #5ea1d8;
}
.cr-avatar--secondary {
  background: #1a6b3a;
}
.cr-avatar--sm {
  width: 36px;
  height: 36px;
  font-size: 14px;
}

.cr-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}
.cr-status .material-symbols-outlined {
  font-size: 14px !important;
}
.cr-status--pending {
  background: #fef3c7;
  color: #d97706;
}
.cr-status--approved {
  background: #dcfce7;
  color: #16a34a;
}
.cr-status--rejected {
  background: #fee2e2;
  color: #dc2626;
}
.cr-status--withdrawn {
  background: #f3e5f5;
  color: #7b1fa2;
}

.cr-role-pill {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: rgba(94, 161, 216, 0.12);
  color: #5ea1d8;
}

.cr-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 40px;
  text-transform: none;
}
.cr-btn .material-symbols-outlined {
  font-size: 18px !important;
}
.cr-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}
.cr-btn--primary {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.cr-btn--primary:hover:not(:disabled) {
  background: #4a8fc4;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3);
}
.cr-btn--ghost {
  background: transparent;
  color: var(--fc-fg, #0f172a);
  border-color: var(--fc-border, #e2e8f0);
}
.cr-btn--ghost:hover:not(:disabled) {
  background: var(--fc-bg2, #f8f9fa);
  border-color: rgba(94, 161, 216, 0.4);
  color: #5ea1d8;
}
.cr-btn--approve {
  background: #dcfce7;
  color: #16a34a;
  border-color: #bbf7d0;
}
.cr-btn--approve:hover:not(:disabled) {
  background: #c9fada;
  transform: translateY(-1px);
}
.cr-btn--reject {
  background: #fee2e2;
  color: #dc2626;
  border-color: #fecaca;
}
.cr-btn--reject:hover:not(:disabled) {
  background: #fdd3d3;
  transform: translateY(-1px);
}
.cr-btn--withdraw {
  background: #fff3e0;
  color: #e65100;
  border-color: #fed7aa;
}
.cr-btn--withdraw:hover:not(:disabled) {
  background: #ffebcc;
  transform: translateY(-1px);
}

.cr-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 0.75rem;
  background: var(--fc-bg, #ffffff);
}

.cr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.cr-table th, .cr-table td {
  padding: 0.875rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--fc-border, #e2e8f0);
}
.cr-table th {
  background: var(--fc-bg2, #f8f9fa);
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--fc-fg-muted, #94a3b8);
}
.cr-table tr:last-child td {
  border-bottom: none;
}
.cr-table tr:not(:last-child):hover td {
  background: var(--fc-bg2, #f8f9fa);
}

.cr-table-person {
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.cr-table-link {
  background: none;
  border: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  text-align: left;
}
.cr-table-link:hover {
  text-decoration: underline;
}

.cr-table-message {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cr-table-empty {
  text-align: center;
  color: var(--fc-fg-muted, #94a3b8);
  padding: 2.5rem !important;
}

.cr-table-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.cr-icon-btn {
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 0.375rem;
  cursor: pointer;
  color: #5ea1d8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.cr-icon-btn .material-symbols-outlined {
  font-size: 1.1rem !important;
}
.cr-icon-btn:hover {
  background: rgba(94, 161, 216, 0.1);
}
.cr-icon-btn--approve {
  color: #16a34a;
}
.cr-icon-btn--approve:hover {
  background: #dcfce7;
}
.cr-icon-btn--reject {
  color: #dc2626;
}
.cr-icon-btn--reject:hover {
  background: #fee2e2;
}
.cr-icon-btn--withdraw {
  color: #e65100;
}
.cr-icon-btn--withdraw:hover {
  background: #fff3e0;
}

.cr-empty {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 1.5rem;
  text-align: center;
}
.cr-empty h3 {
  margin: 0.75rem 0 0.375rem;
  font-size: 1.125rem;
  font-weight: 700;
}
.cr-empty p {
  margin: 0;
  color: var(--fc-fg-muted, #94a3b8);
  font-size: 0.9rem;
}

.cr-empty-icon {
  font-size: 3.5rem !important;
  color: #c0c7d0;
}

.cr-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0);
  transition: background 0.25s ease;
  pointer-events: none;
}
.cr-preview-backdrop--open {
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  pointer-events: all;
}

.cr-preview-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(440px, 100vw);
  background: var(--fc-bg, #ffffff);
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1101;
  border-left: 1px solid var(--fc-border, #e2e8f0);
}
.cr-preview-panel--open {
  transform: translateX(0);
}

.cr-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.125rem 1.5rem;
  border-bottom: 1px solid var(--fc-border, #e2e8f0);
  flex-shrink: 0;
  background: var(--fc-bg, #ffffff);
}

.cr-preview-head-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.cr-preview-head-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  background: rgba(94, 161, 216, 0.14);
  color: #5ea1d8 !important;
  font-size: 1.25rem !important;
}

.cr-preview-head-label {
  font-weight: 700;
  font-size: 1rem;
  color: var(--fc-fg, #0f172a);
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}

.cr-preview-close {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--fc-border, #e2e8f0);
  background: var(--fc-bg2, #f8f9fa);
  border-radius: 10px;
  font-size: 1.25rem;
  cursor: pointer;
  color: var(--fc-fg-muted, #94a3b8);
  line-height: 1;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.cr-preview-close:hover {
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
  border-color: rgba(94, 161, 216, 0.35);
}

.cr-preview-thumb-wrap {
  flex-shrink: 0;
  height: 160px;
  background: var(--fc-bg2, #f8f9fa);
  overflow: hidden;
  border-bottom: 1px solid var(--fc-border, #e2e8f0);
}

.cr-preview-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cr-preview-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, rgba(94, 161, 216, 0.18) 0%, rgba(94, 161, 216, 0.05) 55%, var(--fc-bg2, #f8f9fa) 100%);
}
.cr-preview-thumb-placeholder .material-symbols-outlined {
  font-size: 3.25rem !important;
  color: rgba(94, 161, 216, 0.55);
}

.cr-preview-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  background: var(--fc-bg, #ffffff);
}

.cr-preview-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  color: var(--fc-fg, #0f172a);
  line-height: 1.35;
}

.cr-preview-description {
  margin: 0;
  color: var(--fc-fg-muted, #94a3b8);
  font-size: 0.9rem;
  line-height: 1.55;
}

.cr-preview-section {
  background: var(--fc-bg2, #f8f9fa);
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 14px;
  padding: 1.125rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cr-preview-section-title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--fc-fg-muted, #94a3b8);
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}

.cr-preview-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cr-preview-field-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--fc-fg-muted, #94a3b8);
}

.cr-preview-person {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cr-preview-message,
.cr-preview-response {
  margin: 0;
  padding: 12px;
  border-radius: 8px;
  background: var(--fc-bg, #ffffff);
  border: 1px solid var(--fc-border, #e2e8f0);
  color: var(--fc-fg, #0f172a);
  font-size: 14px;
  line-height: 1.6;
}

.cr-preview-response {
  border-left: 3px solid #5ea1d8;
}

.cr-preview-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
  padding-top: 0.5rem;
  position: sticky;
  bottom: 0;
  background: linear-gradient(to top, var(--fc-bg, #ffffff) 70%, transparent);
}
.cr-preview-actions .cr-btn {
  width: 100%;
  justify-content: center;
  border-radius: 10px;
  min-height: 42px;
}

.cr-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.cr-dialog {
  width: 100%;
  max-width: 480px;
  background: var(--fc-bg, #ffffff);
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.2);
  border: 1px solid var(--fc-border, #e2e8f0);
  overflow: hidden;
}

.cr-dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.125rem 1.5rem;
  border-bottom: 1px solid var(--fc-border, #e2e8f0);
  background: var(--fc-bg, #ffffff);
}
.cr-dialog-head h4 {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  color: var(--fc-fg, #0f172a);
  font-family: "Raleway", "Inter", system-ui, sans-serif;
}
.cr-dialog-head h4 .material-symbols-outlined {
  font-size: 1.35rem !important;
  color: #5ea1d8;
}

.cr-dialog-body {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: var(--fc-bg, #ffffff);
}

.cr-dialog-desc {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--fc-fg-muted, #94a3b8);
}
.cr-dialog-desc strong, .cr-dialog-desc em {
  color: var(--fc-fg, #0f172a);
}

.cr-dialog-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cr-dialog-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--fc-fg-muted, #94a3b8);
}

.cr-dialog-textarea {
  width: 100%;
  padding: 0.75rem 0.875rem;
  border: 1px solid var(--fc-border, #e2e8f0);
  border-radius: 10px;
  font-size: 0.875rem;
  font-family: "Raleway", "Inter", system-ui, sans-serif;
  resize: vertical;
  box-sizing: border-box;
  background: var(--fc-bg2, #f8f9fa);
  color: var(--fc-fg, #0f172a);
}
.cr-dialog-textarea:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
  background: var(--fc-bg, #ffffff);
}

.cr-dialog-foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.5rem;
  border-top: 1px solid var(--fc-border, #e2e8f0);
  background: var(--fc-bg, #ffffff);
}

@keyframes cr-shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
.cr-skel-block, .cr-skel-line, .cr-skel-icon, .cr-skel-avatar {
  background: linear-gradient(90deg, #f3f4f5 25%, #e8e9ea 50%, #f3f4f5 75%);
  background-size: 400px 100%;
  animation: cr-shimmer 1.4s linear infinite;
  border-radius: 0.375rem;
}

.cr-skeleton {
  pointer-events: none;
}

.cr-skel-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.cr-skel-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  flex-shrink: 0;
}

.cr-skel-text-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cr-skel-line {
  height: 14px;
  width: 70%;
}
.cr-skel-line--lg {
  width: 90%;
  height: 20px;
}
.cr-skel-line--sm {
  width: 50%;
  height: 11px;
}

.cr-skel-block {
  height: 56px;
  width: 100%;
  margin: 0 1rem;
  border-radius: 0.5rem;
}
.cr-skel-block--sm {
  height: 36px;
}

body.theme-dark .cr-page {
  background: transparent;
  color: #e5e7eb;
}

body.theme-dark .cr-title {
  color: #f1f5f9 !important;
}

body.theme-dark .cr-subtitle,
body.theme-dark .cr-muted,
body.theme-dark .cr-stat-label,
body.theme-dark .cr-card-email,
body.theme-dark .cr-content-label,
body.theme-dark .cr-date,
body.theme-dark .cr-empty p,
body.theme-dark .cr-dialog-desc,
body.theme-dark .cr-table-empty {
  color: #94a3b8 !important;
}

body.theme-dark .cr-stat-value,
body.theme-dark .cr-card-name,
body.theme-dark .cr-fw6,
body.theme-dark .cr-empty h3,
body.theme-dark .cr-preview-title,
body.theme-dark .cr-dialog-label {
  color: #e5e7eb !important;
}

/* Stat / number cards — solid dark panels (match dashboard cards) */
body.theme-dark .cr-stat-card {
  background: #111827 !important;
  background-color: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.22) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
  color: #e5e7eb !important;
}

body.theme-dark .cr-stat-value {
  color: #f1f5f9 !important;
}

body.theme-dark .cr-stat-label {
  color: #94a3b8 !important;
}

body.theme-dark .cr-stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

body.theme-dark .cr-stat-icon--primary {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #7bbde8 !important;
}

body.theme-dark .cr-stat-icon--pending {
  background: rgba(253, 186, 116, 0.16) !important;
  color: #fde68a !important;
}

body.theme-dark .cr-stat-icon--approved {
  background: rgba(134, 239, 172, 0.14) !important;
  color: #86efac !important;
}

body.theme-dark .cr-stat-icon--rejected {
  background: rgba(252, 165, 165, 0.14) !important;
  color: #fca5a5 !important;
}

body.theme-dark .cr-card,
body.theme-dark .cr-table-wrap,
body.theme-dark .cr-preview-panel,
body.theme-dark .cr-dialog {
  background: var(--fc-bg, #111827) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.25)) !important;
  color: var(--fc-fg, #e5e7eb) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35) !important;
}

body.theme-dark .cr-card:hover {
  border-color: rgba(94, 161, 216, 0.4) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45) !important;
}

body.theme-dark .cr-card-actions {
  background: transparent !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;
}

body.theme-dark .cr-preview-section,
body.theme-dark .cr-message,
body.theme-dark .cr-response {
  background: var(--fc-bg2, #1f2937) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;
}

body.theme-dark .cr-preview-head,
body.theme-dark .cr-preview-body,
body.theme-dark .cr-preview-actions {
  background: var(--fc-bg, #111827) !important;
}

body.theme-dark .cr-preview-thumb-wrap {
  background: var(--fc-bg2, #1f2937) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;
}

body.theme-dark .cr-preview-thumb-placeholder {
  background: linear-gradient(145deg, rgba(94, 161, 216, 0.22) 0%, rgba(94, 161, 216, 0.08) 55%, #1f2937 100%) !important;
}

body.theme-dark .cr-preview-message,
body.theme-dark .cr-preview-response {
  background: var(--fc-bg-head, #0f172a) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;
  color: var(--fc-fg, #e5e7eb) !important;
}

body.theme-dark .cr-preview-close {
  background: var(--fc-bg2, #1f2937) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.3)) !important;
  color: var(--fc-fg-muted, #94a3b8) !important;
}
body.theme-dark .cr-preview-close:hover {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #7bbde8 !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
}

body.theme-dark .cr-preview-backdrop--open {
  background: rgba(0, 0, 0, 0.55) !important;
}

body.theme-dark .cr-card-actions,
body.theme-dark .cr-preview-section,
body.theme-dark .cr-message,
body.theme-dark .cr-response {
  border-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .cr-message p,
body.theme-dark .cr-response p,
body.theme-dark .cr-role-row,
body.theme-dark .cr-role-row strong,
body.theme-dark .cr-table td {
  color: #e5e7eb !important;
}

body.theme-dark .cr-message .material-symbols-outlined {
  color: #94a3b8 !important;
}

body.theme-dark .cr-search,
body.theme-dark .cr-filter-select,
body.theme-dark .cr-dialog-textarea {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e5e7eb !important;
}

body.theme-dark .cr-search-icon {
  color: #94a3b8 !important;
}

body.theme-dark .cr-filter-select option {
  background: #0f172a;
  color: #e5e7eb;
}

/* Tabs — underline only, no box/border wrapper */
body.theme-dark .cr-tabs {
  background: transparent !important;
  border: none !important;
  border-bottom: 2px solid rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .cr-tab {
  color: #94a3b8 !important;
  background: transparent !important;
  border: none !important;
  border-bottom: 3px solid transparent !important;
}
body.theme-dark .cr-tab .material-symbols-outlined {
  color: inherit !important;
}
body.theme-dark .cr-tab:hover {
  color: #cbd5e1 !important;
}
body.theme-dark .cr-tab--active {
  color: #5ea1d8 !important;
  background: transparent !important;
  border-bottom-color: #5ea1d8 !important;
  box-shadow: none !important;
}

body.theme-dark .cr-tab-badge {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
body.theme-dark .cr-tab-badge--neutral {
  background: #64748b !important;
  color: #ffffff !important;
}

/* Card/table toggle — icon only, no box */
body.theme-dark .cr-view-toggle {
  background: transparent !important;
  border: none !important;
  color: #5ea1d8 !important;
}
body.theme-dark .cr-view-toggle .material-symbols-outlined {
  color: #5ea1d8 !important;
}
body.theme-dark .cr-view-toggle:hover {
  background: transparent !important;
  color: #7bbde8 !important;
}
body.theme-dark .cr-view-toggle:hover .material-symbols-outlined {
  color: #7bbde8 !important;
}

/* Status badges */
body.theme-dark .cr-status--pending {
  background: #78350f !important;
  color: #fde68a !important;
}
body.theme-dark .cr-status--approved {
  background: #14532d !important;
  color: #d1fae5 !important;
}
body.theme-dark .cr-status--rejected {
  background: #7f1d1d !important;
  color: #fecaca !important;
}
body.theme-dark .cr-status--withdrawn {
  background: #581c87 !important;
  color: #e9d5ff !important;
}

/* Action buttons */
body.theme-dark .cr-btn--ghost {
  background: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark .cr-btn--ghost .material-symbols-outlined {
  color: #e5e7eb !important;
}
body.theme-dark .cr-btn--approve {
  background: rgba(46, 125, 50, 0.22) !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.35) !important;
}
body.theme-dark .cr-btn--approve .material-symbols-outlined {
  color: #86efac !important;
}
body.theme-dark .cr-btn--reject {
  background: rgba(198, 40, 40, 0.22) !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.35) !important;
}
body.theme-dark .cr-btn--reject .material-symbols-outlined {
  color: #fca5a5 !important;
}
body.theme-dark .cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.22) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.35) !important;
}
body.theme-dark .cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
body.theme-dark .cr-btn--primary {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}

body.theme-dark .cr-content-title,
body.theme-dark .cr-table-link,
body.theme-dark .cr-icon-btn {
  color: #5ea1d8 !important;
}
body.theme-dark .cr-content-title .material-symbols-outlined,
body.theme-dark .cr-table-link .material-symbols-outlined,
body.theme-dark .cr-icon-btn .material-symbols-outlined {
  color: #5ea1d8 !important;
}

body.theme-dark .cr-icon-btn--approve {
  color: #86efac !important;
}
body.theme-dark .cr-icon-btn--reject {
  color: #fca5a5 !important;
}
body.theme-dark .cr-icon-btn--withdraw {
  color: #fdba74 !important;
}

body.theme-dark .cr-content-type-icon,
body.theme-dark .cr-role-row .material-symbols-outlined,
body.theme-dark .cr-stat-icon--primary {
  color: #7bbde8 !important;
}

body.theme-dark .cr-stat-icon--pending {
  color: #fde68a !important;
}

body.theme-dark .cr-stat-icon--approved {
  color: #86efac !important;
}

body.theme-dark .cr-stat-icon--rejected {
  color: #fca5a5 !important;
}

body.theme-dark .cr-date--response,
body.theme-dark .cr-date--response .material-symbols-outlined {
  color: #86efac !important;
}

body.theme-dark .cr-response {
  border-left-color: #5ea1d8 !important;
}
body.theme-dark .cr-response p {
  color: #e5e7eb !important;
}
body.theme-dark .cr-response .material-symbols-outlined {
  color: #5ea1d8 !important;
}

body.theme-dark .cr-preview-field-label {
  color: #94a3b8 !important;
}

body.theme-dark .cr-preview-message {
  color: #e5e7eb !important;
}

body.theme-dark .cr-preview-response {
  background: #111827 !important;
  color: #86efac !important;
  border-left: 3px solid #5ea1d8 !important;
}

body.theme-dark .cr-role-pill {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #7bbde8 !important;
}

body.theme-dark .cr-empty-icon {
  color: #475569 !important;
}

body.theme-dark .cr-preview-close {
  color: #94a3b8 !important;
}
body.theme-dark .cr-preview-close:hover {
  background: rgba(148, 163, 184, 0.12) !important;
  color: #e5e7eb !important;
}

body.theme-dark .cr-table th {
  background: #111827 !important;
  color: #94a3b8 !important;
}

body.theme-dark .cr-table td {
  border-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .cr-table tr:not(:last-child):hover td {
  background: #111827 !important;
}

body.theme-dark .cr-preview-head,
body.theme-dark .cr-dialog-head,
body.theme-dark .cr-dialog-foot,
body.theme-dark .cr-dialog-body {
  border-color: rgba(148, 163, 184, 0.2) !important;
  background: #1f2937 !important;
}

body.theme-dark .cr-preview-thumb-wrap {
  background: #0f172a !important;
}

body.theme-dark .cr-header-icon {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #5ea1d8 !important;
}

/* Maximum specificity — override global app-main-content button/span rules */
body.theme-dark .app-main-content app-collaboration-requests button.cr-btn.cr-btn--ghost,
body.theme-dark .app-main-content app-collaboration-requests .cr-btn.cr-btn--ghost {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark .app-main-content app-collaboration-requests button.cr-btn.cr-btn--ghost .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-btn.cr-btn--ghost .material-symbols-outlined {
  color: #e5e7eb !important;
}
body.theme-dark .app-main-content app-collaboration-requests button.cr-btn.cr-btn--withdraw,
body.theme-dark .app-main-content app-collaboration-requests .cr-btn.cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.28) !important;
  background-color: rgba(230, 81, 0, 0.28) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.4) !important;
}
body.theme-dark .app-main-content app-collaboration-requests button.cr-btn.cr-btn--withdraw .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-btn.cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--pending,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--pending {
  background: #78350f !important;
  background-color: #78350f !important;
  color: #fde68a !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--pending .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--pending .material-symbols-outlined {
  color: #fde68a !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--approved,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--approved {
  background: #14532d !important;
  background-color: #14532d !important;
  color: #d1fae5 !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--approved .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--approved .material-symbols-outlined {
  color: #d1fae5 !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--rejected,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--rejected {
  background: #7f1d1d !important;
  background-color: #7f1d1d !important;
  color: #fecaca !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--rejected .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--rejected .material-symbols-outlined {
  color: #fecaca !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--withdrawn,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--withdrawn {
  background: #581c87 !important;
  background-color: #581c87 !important;
  color: #e9d5ff !important;
}
body.theme-dark .app-main-content app-collaboration-requests span.cr-status.cr-status--withdrawn .material-symbols-outlined,
body.theme-dark .app-main-content app-collaboration-requests .cr-status.cr-status--withdrawn .material-symbols-outlined {
  color: #e9d5ff !important;
}

/* Beat global app-main-content button/text overrides (white text on white/light bg) */
body.theme-dark app-collaboration-requests {
  /* Status badges — cards, table, preview (beat global span color override) */
  /* Preview slide-in panel */
  /* Action confirmation dialog */
}
body.theme-dark app-collaboration-requests .cr-stat-card {
  background: #111827 !important;
  background-color: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.22) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-stat-value {
  color: #f1f5f9 !important;
}
body.theme-dark app-collaboration-requests .cr-stat-label {
  color: #94a3b8 !important;
}
body.theme-dark app-collaboration-requests .cr-stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
body.theme-dark app-collaboration-requests .cr-stat-icon--primary {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #7bbde8 !important;
}
body.theme-dark app-collaboration-requests .cr-stat-icon--pending {
  background: rgba(253, 186, 116, 0.16) !important;
  color: #fde68a !important;
}
body.theme-dark app-collaboration-requests .cr-stat-icon--approved {
  background: rgba(134, 239, 172, 0.14) !important;
  color: #86efac !important;
}
body.theme-dark app-collaboration-requests .cr-stat-icon--rejected {
  background: rgba(252, 165, 165, 0.14) !important;
  color: #fca5a5 !important;
}
body.theme-dark app-collaboration-requests .cr-card {
  background: var(--fc-bg, #111827) !important;
  background-color: var(--fc-bg, #111827) !important;
  border-color: var(--fc-border, rgba(148, 163, 184, 0.25)) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--ghost,
body.theme-dark app-collaboration-requests .cr-btn--ghost,
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--ghost,
body.theme-dark app-collaboration-requests .cr-dialog-foot .cr-btn.cr-btn--ghost,
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn.cr-btn--ghost {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--ghost:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-btn--ghost:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--ghost:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-dialog-foot .cr-btn.cr-btn--ghost:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn.cr-btn--ghost:hover:not(:disabled) {
  background: #374151 !important;
  background-color: #374151 !important;
  color: #f1f5f9 !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--ghost .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-btn--ghost .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--ghost .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-dialog-foot .cr-btn.cr-btn--ghost .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn.cr-btn--ghost .material-symbols-outlined {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--withdraw,
body.theme-dark app-collaboration-requests .cr-btn--withdraw,
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.28) !important;
  background-color: rgba(230, 81, 0, 0.28) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.4) !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--withdraw:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-btn--withdraw:hover:not(:disabled),
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--withdraw:hover:not(:disabled) {
  background: rgba(230, 81, 0, 0.4) !important;
  background-color: rgba(230, 81, 0, 0.4) !important;
  color: #fed7aa !important;
}
body.theme-dark app-collaboration-requests .cr-btn.cr-btn--withdraw .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-btn--withdraw .material-symbols-outlined,
body.theme-dark app-collaboration-requests .cr-card-actions .cr-btn.cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--pending,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--pending {
  background: #78350f !important;
  background-color: #78350f !important;
  color: #fde68a !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--pending .material-symbols-outlined,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--pending .material-symbols-outlined {
  color: #fde68a !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--approved,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--approved {
  background: #14532d !important;
  background-color: #14532d !important;
  color: #d1fae5 !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--approved .material-symbols-outlined,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--approved .material-symbols-outlined {
  color: #d1fae5 !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--rejected,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--rejected {
  background: #7f1d1d !important;
  background-color: #7f1d1d !important;
  color: #fecaca !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--rejected .material-symbols-outlined,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--rejected .material-symbols-outlined {
  color: #fecaca !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--withdrawn,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--withdrawn {
  background: #581c87 !important;
  background-color: #581c87 !important;
  color: #e9d5ff !important;
}
body.theme-dark app-collaboration-requests .cr-status.cr-status--withdrawn .material-symbols-outlined,
body.theme-dark app-collaboration-requests span.cr-status.cr-status--withdrawn .material-symbols-outlined {
  color: #e9d5ff !important;
}
body.theme-dark app-collaboration-requests .cr-message,
body.theme-dark app-collaboration-requests .cr-response {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.12) !important;
}
body.theme-dark app-collaboration-requests .cr-message p,
body.theme-dark app-collaboration-requests .cr-response p {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-message .material-symbols-outlined {
  color: #94a3b8 !important;
}
body.theme-dark app-collaboration-requests .cr-response {
  border-left: 3px solid #5ea1d8 !important;
  border-top: none !important;
  border-right: none !important;
  border-bottom: none !important;
}
body.theme-dark app-collaboration-requests .cr-response .material-symbols-outlined {
  color: #5ea1d8 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-message {
  color: #e5e7eb !important;
  background: transparent !important;
}
body.theme-dark app-collaboration-requests .cr-preview-response {
  background: #111827 !important;
  color: #86efac !important;
  border-left: 3px solid #5ea1d8 !important;
}
body.theme-dark app-collaboration-requests .cr-card-actions {
  background: #111827 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-panel {
  background: #1f2937 !important;
  color: #e5e7eb !important;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.45) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-body {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-preview-head {
  background: #1f2937 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-head-label {
  color: #f1f5f9 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-head-icon {
  color: #5ea1d8 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-title {
  color: #f1f5f9 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-section {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-section-title,
body.theme-dark app-collaboration-requests .cr-preview-field-label {
  color: #94a3b8 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-thumb-wrap {
  background: #0f172a !important;
}
body.theme-dark app-collaboration-requests .cr-preview-thumb-placeholder {
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.14) 0%, #0f172a 100%) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-thumb-placeholder .material-symbols-outlined {
  color: rgba(94, 161, 216, 0.55) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-close {
  color: #94a3b8 !important;
  background: transparent !important;
}
body.theme-dark app-collaboration-requests .cr-preview-close:hover {
  background: rgba(148, 163, 184, 0.12) !important;
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-preview-person .cr-fw6,
body.theme-dark app-collaboration-requests .cr-preview-field .cr-fw6 {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-preview-person .cr-muted,
body.theme-dark app-collaboration-requests .cr-preview-field .cr-muted {
  color: #94a3b8 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--primary {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--primary .material-symbols-outlined {
  color: #ffffff !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--approve {
  background: rgba(46, 125, 50, 0.22) !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--approve .material-symbols-outlined {
  color: #86efac !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--reject {
  background: rgba(198, 40, 40, 0.22) !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--reject .material-symbols-outlined {
  color: #fca5a5 !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.22) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-preview-actions .cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
body.theme-dark app-collaboration-requests .cr-dialog {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-head,
body.theme-dark app-collaboration-requests .cr-dialog-body,
body.theme-dark app-collaboration-requests .cr-dialog-foot {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-head h4 {
  color: #f1f5f9 !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-head h4 .material-symbols-outlined {
  color: inherit !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-desc {
  color: #94a3b8 !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-desc strong,
body.theme-dark app-collaboration-requests .cr-dialog-desc em {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-label {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-textarea {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-foot .cr-btn--ghost {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark app-collaboration-requests .cr-dialog-foot .cr-btn--ghost .material-symbols-outlined {
  color: #e5e7eb !important;
}
body.theme-dark app-collaboration-requests .cr-preview-section .cr-role-pill {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #7bbde8 !important;
}

@media (max-width: 639px) {
  .cr-page {
    padding: 0.5rem 0.75rem 4rem;
  }
  .cr-title {
    font-size: 1.375rem;
  }
  .cr-card-actions {
    flex-direction: column;
  }
  .cr-card-actions .cr-btn {
    width: 100%;
    justify-content: center;
  }
  .cr-preview-panel {
    width: 100vw;
  }
  /* Dark mode mobile: underline tabs, no box wrapper */
  body.theme-dark .cr-tabs {
    background: transparent !important;
    border: none !important;
    border-bottom: 2px solid rgba(148, 163, 184, 0.15) !important;
    padding: 0;
    border-radius: 0;
    gap: 0;
  }
  body.theme-dark .cr-tab {
    flex: 1;
    justify-content: center;
    margin-bottom: -2px;
    padding: 0.625rem 0.5rem;
    font-size: 0.8125rem;
    border-radius: 0;
    background: transparent !important;
    border-bottom: 3px solid transparent !important;
  }
  body.theme-dark .cr-tab--active {
    color: #5ea1d8 !important;
    background: transparent !important;
    border-bottom-color: #5ea1d8 !important;
    box-shadow: none !important;
  }
  body.theme-dark .cr-tab--active .material-symbols-outlined {
    color: #5ea1d8 !important;
  }
  body.theme-dark .cr-view-toggle {
    flex-shrink: 0;
    background: transparent !important;
    border: none !important;
  }
  body.theme-dark .cr-view-toggle .material-symbols-outlined {
    color: #5ea1d8 !important;
  }
}
/* Reinforce dark-mode via host context (Angular encapsulation) */
:host-context(body.theme-dark) {
  /* Preview slide-in panel */
  /* Action confirmation dialog */
}
:host-context(body.theme-dark) .cr-tab {
  background: transparent !important;
}
:host-context(body.theme-dark) .cr-tab--active {
  color: #5ea1d8 !important;
  background: transparent !important;
  border-bottom-color: #5ea1d8 !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .cr-view-toggle {
  background: transparent !important;
  border: none !important;
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-view-toggle .material-symbols-outlined {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-view-toggle:hover,
:host-context(body.theme-dark) .cr-view-toggle:hover .material-symbols-outlined {
  color: #7bbde8 !important;
}
:host-context(body.theme-dark) .cr-btn--ghost,
:host-context(body.theme-dark) .cr-btn.cr-btn--ghost,
:host-context(body.theme-dark) .cr-card-actions .cr-btn.cr-btn--ghost,
:host-context(body.theme-dark) .cr-dialog-foot .cr-btn.cr-btn--ghost {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .cr-btn--ghost:hover:not(:disabled),
:host-context(body.theme-dark) .cr-btn.cr-btn--ghost:hover:not(:disabled),
:host-context(body.theme-dark) .cr-card-actions .cr-btn.cr-btn--ghost:hover:not(:disabled),
:host-context(body.theme-dark) .cr-dialog-foot .cr-btn.cr-btn--ghost:hover:not(:disabled) {
  background: #374151 !important;
  background-color: #374151 !important;
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .cr-btn--ghost .material-symbols-outlined,
:host-context(body.theme-dark) .cr-btn.cr-btn--ghost .material-symbols-outlined,
:host-context(body.theme-dark) .cr-card-actions .cr-btn.cr-btn--ghost .material-symbols-outlined,
:host-context(body.theme-dark) .cr-dialog-foot .cr-btn.cr-btn--ghost .material-symbols-outlined {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-btn.cr-btn--withdraw,
:host-context(body.theme-dark) .cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.28) !important;
  background-color: rgba(230, 81, 0, 0.28) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.4) !important;
}
:host-context(body.theme-dark) .cr-btn.cr-btn--withdraw .material-symbols-outlined,
:host-context(body.theme-dark) .cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--pending,
:host-context(body.theme-dark) span.cr-status.cr-status--pending {
  background: #78350f !important;
  background-color: #78350f !important;
  color: #fde68a !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--pending .material-symbols-outlined,
:host-context(body.theme-dark) span.cr-status.cr-status--pending .material-symbols-outlined {
  color: #fde68a !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--approved,
:host-context(body.theme-dark) span.cr-status.cr-status--approved {
  background: #14532d !important;
  background-color: #14532d !important;
  color: #d1fae5 !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--approved .material-symbols-outlined,
:host-context(body.theme-dark) span.cr-status.cr-status--approved .material-symbols-outlined {
  color: #d1fae5 !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--rejected,
:host-context(body.theme-dark) span.cr-status.cr-status--rejected {
  background: #7f1d1d !important;
  background-color: #7f1d1d !important;
  color: #fecaca !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--rejected .material-symbols-outlined,
:host-context(body.theme-dark) span.cr-status.cr-status--rejected .material-symbols-outlined {
  color: #fecaca !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--withdrawn,
:host-context(body.theme-dark) span.cr-status.cr-status--withdrawn {
  background: #581c87 !important;
  background-color: #581c87 !important;
  color: #e9d5ff !important;
}
:host-context(body.theme-dark) .cr-status.cr-status--withdrawn .material-symbols-outlined,
:host-context(body.theme-dark) span.cr-status.cr-status--withdrawn .material-symbols-outlined {
  color: #e9d5ff !important;
}
:host-context(body.theme-dark) .cr-message,
:host-context(body.theme-dark) .cr-response {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .cr-message p,
:host-context(body.theme-dark) .cr-response p {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-message .material-symbols-outlined {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .cr-response {
  border-left: 3px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-response .material-symbols-outlined {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-preview-message {
  color: #e5e7eb !important;
  background: transparent !important;
}
:host-context(body.theme-dark) .cr-preview-response {
  background: #111827 !important;
  color: #86efac !important;
  border-left: 3px solid #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-card-actions {
  background: #111827 !important;
}
:host-context(body.theme-dark) .cr-preview-panel,
:host-context(body.theme-dark) .cr-preview-body {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-preview-head {
  background: #1f2937 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .cr-preview-head-label,
:host-context(body.theme-dark) .cr-preview-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .cr-preview-head-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-preview-section {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .cr-preview-section-title,
:host-context(body.theme-dark) .cr-preview-field-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .cr-preview-thumb-wrap {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .cr-preview-thumb-placeholder {
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.14) 0%, #0f172a 100%) !important;
}
:host-context(body.theme-dark) .cr-preview-thumb-placeholder .material-symbols-outlined {
  color: rgba(94, 161, 216, 0.55) !important;
}
:host-context(body.theme-dark) .cr-preview-close {
  color: #94a3b8 !important;
  background: transparent !important;
}
:host-context(body.theme-dark) .cr-preview-close:hover {
  background: rgba(148, 163, 184, 0.12) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-preview-person .cr-fw6,
:host-context(body.theme-dark) .cr-preview-field .cr-fw6 {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-preview-person .cr-muted,
:host-context(body.theme-dark) .cr-preview-field .cr-muted {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--primary {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--primary .material-symbols-outlined {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--approve {
  background: rgba(46, 125, 50, 0.22) !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.35) !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--approve .material-symbols-outlined {
  color: #86efac !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--reject {
  background: rgba(198, 40, 40, 0.22) !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.35) !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--reject .material-symbols-outlined {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--withdraw {
  background: rgba(230, 81, 0, 0.22) !important;
  color: #fdba74 !important;
  border-color: rgba(253, 186, 116, 0.35) !important;
}
:host-context(body.theme-dark) .cr-preview-actions .cr-btn--withdraw .material-symbols-outlined {
  color: #fdba74 !important;
}
:host-context(body.theme-dark) .cr-dialog,
:host-context(body.theme-dark) .cr-dialog-head,
:host-context(body.theme-dark) .cr-dialog-body,
:host-context(body.theme-dark) .cr-dialog-foot {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-dialog-head h4 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .cr-dialog-head h4 .material-symbols-outlined {
  color: inherit !important;
}
:host-context(body.theme-dark) .cr-dialog-desc {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .cr-dialog-desc strong, :host-context(body.theme-dark) .cr-dialog-desc em {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-dialog-label {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .cr-dialog-textarea {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e5e7eb !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/collaboration-requests/collaboration-requests.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;qEAAA;AAgCA;EAAkB,kCALN;EAKqB,oBAAA;AAxBjC;;AAyBA;EAAkB,gBAAA;EAAkB,iBAAA;AApBpC;;AAsBA;EACE,+DAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,mCAAA;EACA,sBAAA;AAnBF;;AAwBA;EACE,sDAvBU;EAwBV,4BA1BU;EA2BV,4BAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;AArBF;AAuBE;EAXF;IAYI,uBAAA;EApBF;AACF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAlFU;EAmFV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAtBF;AAwBE;EAA6B,4BAAA;AArB/B;;AAwBA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AArBF;;AAwBA;EACE,SAAA;EACA,iBAAA;EACA,kCAhFU;AA2DZ;;AA0BA;EACE,aAAA;EACA,WAAA;EACA,kDAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAnGU;EAoGV,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,qDAAA;EACA,sDAzGU;AAkFZ;AAyBE;EAA6B,8BAAA;AAtB/B;AAwBE;EAAU,cAnIA;AA8GZ;AAuBE;EACE,cAtIQ;EAuIR,4BAvIQ;AAkHZ;;AAyBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBArJU;EAsJV,WAAA;EACA,cAAA;AAtBF;AAwBE;EAAa,mBAAA;AArBf;;AA0BA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,qBAAA;AAvBF;AAyBE;EANF;IAOI,qCAAA;EAtBF;AACF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iCA5JU;EA6JV,sBAAA;EACA,yCAAA;EACA,2CAAA;AAtBF;;AA0BE;EACE,8BAAA;EACA,oCAAA;EACA,kDAAA;EACA,oDAAA;EACA,yBAAA;AAvBJ;AA0BE;EACE,yBAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;AA1BJ;AA6BE;EACE,+CAAA;EACA,yBAAA;AA3BJ;AA8BE;EACE,gDAAA;EACA,yBAAA;AA5BJ;AA+BE;EACE,gDAAA;EACA,yBAAA;AA7BJ;AAgCE;EACE,gDAAA;EACA,yBAAA;AA9BJ;;AAkCA;EACE,8BAAA;EACA,cAAA;AA/BF;AAiCE;EAAc,cAvOJ;AAyMZ;AA+BE;EAAc,cA/NJ;AAmMZ;AA6BE;EAAc,cAvOJ;AA6MZ;AA2BE;EAAc,cAtOJ;AA8MZ;;AA2BA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,6CAAA;AAxBF;;AA2BA;EACE,oBAAA;EACA,kCAjOU;EAkOV,eAAA;AAxBF;;AA6BA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,kCA1PU;EA2PV,8BAAA;EACA,oBAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,4BAAA;EACA,2CAAA;EACA,qBAAA;EACA,mBAAA;EACA,sDAtQU;EAuQV,iCA3QU;EA4QV,4BA1QU;EA2QV,sBAAA;EACA,8BAAA;AA1BF;AA4BE;EACE,aAAA;EACA,qBApSQ;EAqSR,8CAAA;AA1BJ;;AA8BA;EACE,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,2CAAA;EACA,qBAAA;EACA,mBAAA;EACA,sDA1RU;EA2RV,iCA/RU;EAgSV,4BA9RU;EA+RV,eAAA;EACA,YAAA;AA3BF;AA6BE;EAAU,aAAA;EAAe,qBAtTf;AA6RZ;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,2CAAA;EACA,qBAAA;EACA,iCAhTU;EAiTV,kCA9SU;EA+SV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yCAAA;AAzBF;AA2BE;EAA6B,8BAAA;AAxB/B;AAyBE;EAAU,oCAAA;EAAsC,cA3UtC;AAsTZ;;AA0BA;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AAvBF;AAyBE;EALF;IAMI,qCAAA;EAtBF;AACF;AAwBE;EATF;IAUI,qCAAA;EArBF;AACF;;AAwBA;EACE,iCA7UU;EA8UV,2CAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,wDAAA;EACA,sBAAA;AArBF;AAuBE;EACE,6CAAA;EACA,sCAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AAtBF;;AAyBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,4BA9WU;EA+WV,sDA7WU;AAuVZ;;AAyBA;EACE,SAAA;EACA,eAAA;EACA,kCApXU;AA8VZ;;AAyBA;EACE,eAAA;EACA,cA9YU;AAwXZ;;AAyBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,cAhaU;EAiaV,6BAAA;EACA,cAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kCA7ZU;AAuYZ;;AAyBA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cA9bU;EA+bV,eAAA;EACA,gBAAA;EACA,sDA3aU;EA4aV,sDAAA;EAAA,8CAAA;EAAA,6EAAA;EACA,gBAAA;AAtBF;AAwBE;EAA6B,8BAAA;AArB/B;AAsBE;EACE,cAtcQ;EAucR,0BAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4BA7bU;EA8bV,gBAAA;AArBF;AAuBE;EAA6B,cApdnB;EAodoC,0BAAA;AAnBhD;AAoBE;EAAS,4BAjcC;AAgbZ;;AAoBA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,kCA5cU;EA6cV,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;AAjBF;AAmBE;EACE,SAAA;EACA,gBAAA;EACA,OAAA;EACA,4BAldQ;AAicZ;AAmBE;EACE,0BAAA;EACA,cAAA;EACA,kCAtdQ;EAudR,eAAA;AAjBJ;;AAqBA;EACE,0BAjfU;AA+dZ;AAmBE;EAA6B,cAlfnB;AAkeZ;;AAmBA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kCA5eU;AA4dZ;AAkBE;EAA6B,4BAAA;AAf/B;AAgBE;EAAc,cAlgBJ;AAqfZ;AAaiC;EAA6B,cAlgBlD;AAwfZ;;AAaA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,+CAAA;EACA,uBAAA;AAVF;AAYE;EACE,OAAA;EACA,YAAA;EACA,uBAAA;AAVJ;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,sDA7gBU;AAggBZ;AAeE;EAAe,mBAriBL;AAyhBZ;AAaE;EAAe,mBAAA;AAVjB;AAWE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AATJ;;AAeA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sDAtiBU;AA0hBZ;AAcE;EAA6B,0BAAA;AAX/B;AAaE;EAAe,mBAxjBL;EAwjBgC,cAvjBhC;AA8iBZ;AAUE;EAAe,mBAvjBJ;EAujB+B,cAtjB/B;AAgjBb;AAOE;EAAe,mBAtjBJ;EAsjB+B,cArjB/B;AAkjBb;AAIE;EAAe,mBArjBH;EAqjB8B,cApjB9B;AAojBd;;AAKA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,cA/kBU;AA6kBZ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,sDAxkBU;EAykBV,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAJF;AAME;EAA6B,0BAAA;AAH/B;AAKE;EAAa,aAAA;EAAe,mBAAA;EAAqB,0BAAA;EAA4B,2BAAA;AAC/E;AACE;EACE,mBAzmBQ;EA0mBR,WAAA;EACA,qBA3mBQ;AA4mBZ;AAAI;EACE,mBA5mBM;EA6mBN,2BAAA;EACA,6CAAA;AAEN;AAEE;EACE,uBAAA;EACA,4BAjmBQ;EAkmBR,uCAnmBQ;AAmmBZ;AACI;EACE,kCAxmBM;EAymBN,qCAAA;EACA,cA1nBM;AA2nBZ;AAGE;EACE,mBA5nBQ;EA6nBR,cA9nBQ;EA+nBR,qBAAA;AADJ;AAEI;EACE,mBAAA;EACA,2BAAA;AAAN;AAIE;EACE,mBApoBQ;EAqoBR,cAtoBQ;EAuoBR,qBAAA;AAFJ;AAGI;EACE,mBAAA;EACA,2BAAA;AADN;AAKE;EACE,mBA5oBS;EA6oBT,cA9oBQ;EA+oBR,qBAAA;AAHJ;AAII;EACE,mBAAA;EACA,2BAAA;AAFN;;AASA;EACE,gBAAA;EACA,2CAAA;EACA,sBAAA;EACA,iCAjpBU;AA2oBZ;;AASA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AANF;AAQE;EACE,sBAAA;EACA,gBAAA;EACA,kDAAA;AANJ;AASE;EACE,kCAlqBQ;EAmqBR,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kCAlqBQ;AA2pBZ;AAUE;EAAmB,mBAAA;AAPrB;AAQE;EAA+B,kCA3qBrB;AAsqBZ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AALF;;AAQA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,cAxsBU;EAysBV,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sDAtrBU;EAurBV,gBAAA;AALF;AAME;EAAU,0BAAA;AAHZ;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kCArsBU;EAssBV,0BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,cA5uBU;EA6uBV,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAHF;AAKE;EAA6B,4BAAA;AAF/B;AAIE;EAAU,mCAAA;AADZ;AAEE;EAAa,cAnvBH;AAovBZ;AADgC;EAAU,mBAlvB9B;AAsvBZ;AAHE;EAAa,cAlvBH;AAwvBZ;AANgC;EAAU,mBAjvB9B;AA0vBZ;AARE;EAAa,cAjvBH;AA4vBZ;AAXgC;EAAU,mBAhvB7B;AA8vBb;;AATA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAYF;AAVE;EAAK,0BAAA;EAA4B,mBAAA;EAAqB,gBAAA;AAexD;AAdE;EAAK,SAAA;EAAW,kCAjvBN;EAivBqB,iBAAA;AAmBjC;;AAhBA;EACE,4BAAA;EACA,cAAA;AAmBF;;AAdA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,4BAAA;EACA,iCAAA;EACA,oBAAA;AAiBF;AAfE;EACE,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;AAiBJ;;AAbA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,iCApxBU;EAqxBV,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uDAAA;EACA,aAAA;EACA,gDAAA;AAgBF;AAdE;EAAU,wBAAA;AAiBZ;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kDAAA;EACA,cAAA;EACA,iCAxyBU;AAyzBZ;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAiBF;;AAdA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,yBAAA;EACA,6BAAA;AAiBF;;AAdA;EACE,gBAAA;EACA,eAAA;EACA,4BA9zBU;EA+zBV,sDA7zBU;AA80BZ;;AAdA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,kCA70BU;EA80BV,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCA50BU;EA60BV,cAAA;EACA,6DAAA;AAiBF;AAfE;EACE,mCAAA;EACA,cAv2BQ;EAw2BR,sCAAA;AAiBJ;;AAbA;EACE,cAAA;EACA,aAAA;EACA,kCA/1BU;EAg2BV,gBAAA;EACA,kDAAA;AAgBF;;AAbA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAgBF;;AAbA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2HAAA;AAgBF;AAdE;EACE,6BAAA;EACA,+BAAA;AAgBJ;;AAZA;EACE,OAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iCA73BU;AA44BZ;;AAZA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,sDAh4BU;EAi4BV,4BAn4BU;EAo4BV,iBAAA;AAeF;;AAZA;EACE,SAAA;EACA,kCAx4BU;EAy4BV,iBAAA;EACA,iBAAA;AAeF;;AAZA;EACE,kCAn5BU;EAo5BV,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAeF;;AAZA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kCA75BU;EA85BV,sDA75BU;AA46BZ;;AAZA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAeF;;AAZA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kCA56BU;AA27BZ;;AAZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAeF;;AAZA;;EAEE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,iCA77BU;EA87BV,2CAAA;EACA,4BA77BU;EA87BV,eAAA;EACA,gBAAA;AAeF;;AAZA;EACE,8BAAA;AAeF;;AAZA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,2EAAA;AAeF;AAbE;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAeJ;;AATA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAYF;;AATA;EACE,WAAA;EACA,gBAAA;EACA,iCA5+BU;EA6+BV,mBAAA;EACA,6CAAA;EACA,2CAAA;EACA,gBAAA;AAYF;;AATA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kDAAA;EACA,iCAz/BU;AAqgCZ;AAVE;EACE,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAhgCQ;EAigCR,sDA//BQ;AA2gCZ;AAVI;EACE,6BAAA;EACA,cAzhCM;AAqiCZ;;AAPA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iCAjhCU;AA2hCZ;;AAPA;EACE,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCArhCU;AA+hCZ;AARE;EACE,4BAzhCQ;AAmiCZ;;AANA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AASF;;AANA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kCAviCU;AAgjCZ;;AANA;EACE,WAAA;EACA,yBAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDA/iCU;EAgjCV,gBAAA;EACA,sBAAA;EACA,kCAxjCU;EAyjCV,4BArjCU;AA8jCZ;AAPE;EACE,aAAA;EACA,qBA7kCQ;EA8kCR,8CAAA;EACA,iCA7jCQ;AAskCZ;;AALA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;EACA,iCAvkCU;AA+kCZ;;AAHA;EACE;IAAO,6BAAA;EAOP;EANA;IAAO,4BAAA;EASP;AACF;AAPA;EACE,yEAAA;EACA,2BAAA;EACA,0CAAA;EACA,uBAAA;AASF;;AANA;EACE,oBAAA;AASF;;AANA;EAEE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AAQF;;AALA;EAEE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AAOF;;AAJA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAOF;;AAJA;EAEE,YAAA;EACA,UAAA;AAMF;AAJE;EAAQ,UAAA;EAAY,YAAA;AAQtB;AAPE;EAAQ,UAAA;EAAY,YAAA;AAWtB;;AARA;EAEE,YAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;AAUF;AARE;EAAQ,YAAA;AAWV;;AANA;EACE,uBAAA;EACA,cAAA;AASF;;AANA;EACE,yBAAA;AASF;;AANA;;;;;;;;;EASE,yBAAA;AASF;;AANA;;;;;;EAME,yBAAA;AASF;;AANA,oEAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,sDAAA;EACA,oDAAA;EACA,yBAAA;AASF;;AANA;EACE,yBAAA;AASF;;AANA;EACE,yBAAA;AASF;;AANA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;AASF;;AANA;EACE,+CAAA;EACA,yBAAA;AASF;;AANA;EACE,gDAAA;EACA,yBAAA;AASF;;AANA;EACE,gDAAA;EACA,yBAAA;AASF;;AANA;EACE,gDAAA;EACA,yBAAA;AASF;;AANA;;;;EAIE,4CAAA;EACA,oEAAA;EACA,uCAAA;EACA,qDAAA;AASF;;AANA;EACE,gDAAA;EACA,qDAAA;AASF;;AANA;EACE,kCAAA;EACA,mEAAA;AASF;;AANA;;;EAGE,6CAAA;EACA,mEAAA;AASF;;AANA;;;EAGE,4CAAA;AASF;;AANA;EACE,6CAAA;EACA,mEAAA;AASF;;AANA;EACE,uHAAA;AASF;;AADA;;EAEE,iDAAA;EACA,mEAAA;EACA,uCAAA;AAIF;;AADA;EACE,6CAAA;EACA,mEAAA;EACA,6CAAA;AAIF;AAFE;EACE,+CAAA;EACA,yBAAA;EACA,gDAAA;AAIJ;;AAAA;EACE,0CAAA;AAGF;;AAAA;;;;EAIE,kDAAA;AAGF;;AAAA;;;;;EAKE,yBAAA;AAGF;;AAAA;EACE,yBAAA;AAGF;;AAAA;;;EAGE,8BAAA;EACA,iDAAA;EACA,yBAAA;AAGF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,mBAAA;EACA,cAAA;AAGF;;AAAA,iDAAA;AACA;EACE,kCAAA;EACA,uBAAA;EACA,6DAAA;AAGF;;AAAA;EACE,yBAAA;EACA,kCAAA;EACA,uBAAA;EACA,+CAAA;AAGF;AADE;EACE,yBAAA;AAGJ;AAAE;EACE,yBAAA;AAEJ;AACE;EACE,yBAAA;EACA,kCAAA;EACA,uCAAA;EACA,2BAAA;AACJ;;AAGA;EACE,8BAAA;EACA,yBAAA;AAAF;AAEE;EACE,8BAAA;EACA,yBAAA;AAAJ;;AAIA,0CAAA;AACA;EACE,kCAAA;EACA,uBAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,kCAAA;EACA,yBAAA;AAFJ;AAII;EACE,yBAAA;AAFN;;AAOA,kBAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AALJ;AAQE;EACE,8BAAA;EACA,yBAAA;AANJ;AASE;EACE,8BAAA;EACA,yBAAA;AAPJ;AAUE;EACE,8BAAA;EACA,yBAAA;AARJ;;AAYA,mBAAA;AAEE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAcE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;AAgBE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAdJ;AAgBI;EACE,yBAAA;AAdN;AAkBE;EACE,6CAAA;EACA,yBAAA;EACA,kDAAA;AAhBJ;AAkBI;EACE,yBAAA;AAhBN;AAoBE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAlBJ;;AAsBA;;;EAGE,yBAAA;AAnBF;AAqBE;;;EACE,yBAAA;AAjBJ;;AAsBE;EAAa,yBAAA;AAlBf;AAmBE;EAAa,yBAAA;AAhBf;AAiBE;EAAc,yBAAA;AAdhB;;AAiBA;;;EAGE,yBAAA;AAdF;;AAiBA;EAAyC,yBAAA;AAbzC;;AAcA;EAA0C,yBAAA;AAV1C;;AAWA;EAA0C,yBAAA;AAP1C;;AASA;;EAEE,yBAAA;AANF;;AASA;EACE,qCAAA;AANF;AAQE;EAAI,yBAAA;AALN;AAME;EAA6B,yBAAA;AAH/B;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,8BAAA;EACA,yBAAA;EACA,yCAAA;AAHF;;AAMA;EACE,+CAAA;EACA,yBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;AAKE;EACE,gDAAA;EACA,yBAAA;AAHJ;;AAOA;EACE,8BAAA;EACA,yBAAA;AAJF;;AAOA;EACE,kDAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;;;;EAIE,iDAAA;EACA,8BAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;EACE,+CAAA;EACA,yBAAA;AAJF;;AAOA,6EAAA;AAEE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AALJ;AAOI;;EACE,yBAAA;AAJN;AAQE;;EAEE,6CAAA;EACA,mDAAA;EACA,yBAAA;EACA,iDAAA;AANJ;AAQI;;EACE,yBAAA;AALN;AASE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAPJ;AASI;;EACE,yBAAA;AANN;AAUE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AARJ;AAUI;;EACE,yBAAA;AAPN;AAWE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AATJ;AAWI;;EACE,yBAAA;AARN;AAYE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAVJ;AAYI;;EACE,yBAAA;AATN;;AAcA,sFAAA;AACA;EA6FE,4EAAA;EAqFA,2BAAA;EAyGA,+BAAA;AAnSF;AASE;EACE,8BAAA;EACA,oCAAA;EACA,sDAAA;EACA,oDAAA;EACA,yBAAA;AAPJ;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,yBAAA;AATJ;AAYE;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;AAaE;EACE,+CAAA;EACA,yBAAA;AAXJ;AAcE;EACE,gDAAA;EACA,yBAAA;AAZJ;AAeE;EACE,gDAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,gDAAA;EACA,yBAAA;AAdJ;AAiBE;EACE,4CAAA;EACA,kDAAA;EACA,oEAAA;EACA,qDAAA;AAfJ;AAkBE;;;;;EAKE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAhBJ;AAkBI;;;;;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAZN;AAeI;;;;;EACE,yBAAA;AATN;AAaE;;;EAGE,6CAAA;EACA,mDAAA;EACA,yBAAA;EACA,iDAAA;AAXJ;AAaI;;;EACE,4CAAA;EACA,kDAAA;EACA,yBAAA;AATN;AAYI;;;EACE,yBAAA;AARN;AAaE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAXJ;AAaI;;EACE,yBAAA;AAVN;AAcE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAZJ;AAcI;;EACE,yBAAA;AAXN;AAeE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAbJ;AAeI;;EACE,yBAAA;AAZN;AAgBE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAdJ;AAgBI;;EACE,yBAAA;AAbN;AAiBE;;EAEE,8BAAA;EACA,sDAAA;AAfJ;AAiBI;;EACE,yBAAA;AAdN;AAkBE;EACE,yBAAA;AAhBJ;AAmBE;EACE,yCAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;AAjBJ;AAmBI;EACE,yBAAA;AAjBN;AAqBE;EACE,yBAAA;EACA,kCAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,yBAAA;EACA,yCAAA;AApBJ;AAuBE;EACE,8BAAA;AArBJ;AAyBE;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAvBJ;AA0BE;EACE,8BAAA;EACA,yBAAA;AAxBJ;AA2BE;EACE,8BAAA;EACA,wDAAA;AAzBJ;AA4BE;EACE,yBAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,yBAAA;AA5BJ;AA+BE;EACE,8BAAA;EACA,iDAAA;AA7BJ;AAgCE;;EAEE,yBAAA;AA9BJ;AAiCE;EACE,8BAAA;AA/BJ;AAkCE;EACE,yFAAA;AAhCJ;AAkCI;EACE,0CAAA;AAhCN;AAoCE;EACE,yBAAA;EACA,kCAAA;AAlCJ;AAoCI;EACE,gDAAA;EACA,yBAAA;AAlCN;AAsCE;;EAEE,yBAAA;AApCJ;AAuCE;;EAEE,yBAAA;AArCJ;AAwCE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAtCJ;AAwCI;EACE,yBAAA;AAtCN;AA0CE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAxCJ;AA0CI;EAA6B,yBAAA;AAvCjC;AA0CE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAxCJ;AA0CI;EAA6B,yBAAA;AAvCjC;AA0CE;EACE,6CAAA;EACA,yBAAA;EACA,kDAAA;AAxCJ;AA0CI;EAA6B,yBAAA;AAvCjC;AA2CE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AAzCJ;AA4CE;;;EAGE,8BAAA;EACA,iDAAA;AA1CJ;AA6CE;EACE,yBAAA;AA3CJ;AA6CI;EACE,yBAAA;AA3CN;AA+CE;EACE,yBAAA;AA7CJ;AA+CI;;EAEE,yBAAA;AA7CN;AAiDE;EACE,yBAAA;AA/CJ;AAkDE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AAhDJ;AAmDE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAjDJ;AAmDI;EACE,yBAAA;AAjDN;AAqDE;EACE,+CAAA;EACA,yBAAA;AAnDJ;;AAyDA;EACE;IAAW,4BAAA;EArDX;EAsDA;IAAY,mBAAA;EAnDZ;EAoDA;IAAmB,sBAAA;EAjDnB;EAiD2C;IAAU,WAAA;IAAa,uBAAA;EA7ClE;EA8CA;IAAoB,YAAA;EA3CpB;EA6CA,qDAAA;EACA;IACE,kCAAA;IACA,uBAAA;IACA,6DAAA;IACA,UAAA;IACA,gBAAA;IACA,MAAA;EA3CF;EA8CA;IACE,OAAA;IACA,uBAAA;IACA,mBAAA;IACA,wBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kCAAA;IACA,+CAAA;EA5CF;EA8CE;IACE,yBAAA;IACA,kCAAA;IACA,uCAAA;IACA,2BAAA;EA5CJ;EA8CI;IACE,yBAAA;EA5CN;EAiDA;IACE,cAAA;IACA,kCAAA;IACA,uBAAA;EA/CF;EAiDE;IACE,yBAAA;EA/CJ;AACF;AAmDA,iEAAA;AACA;EAqIE,2BAAA;EA+FA,+BAAA;AAnRF;AAgDE;EACE,kCAAA;AA9CJ;AAiDE;EACE,yBAAA;EACA,kCAAA;EACA,uCAAA;EACA,2BAAA;AA/CJ;AAkDE;EACE,kCAAA;EACA,uBAAA;EACA,yBAAA;AAhDJ;AAmDE;EACE,yBAAA;AAjDJ;AAoDE;;EAEE,yBAAA;AAlDJ;AAqDE;;;;EAIE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAnDJ;AAqDI;;;;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAhDN;AAmDI;;;;EACE,yBAAA;AA9CN;AAkDE;;EAEE,6CAAA;EACA,mDAAA;EACA,yBAAA;EACA,iDAAA;AAhDJ;AAkDI;;EACE,yBAAA;AA/CN;AAmDE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAjDJ;AAmDI;;EAA6B,yBAAA;AA/CjC;AAkDE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAhDJ;AAkDI;;EAA6B,yBAAA;AA9CjC;AAiDE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AA/CJ;AAiDI;;EAA6B,yBAAA;AA7CjC;AAgDE;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;AA9CJ;AAgDI;;EAA6B,yBAAA;AA5CjC;AA+CE;;EAEE,8BAAA;EACA,sDAAA;AA7CJ;AAgDE;;EAEE,yBAAA;AA9CJ;AAiDE;EACE,yBAAA;AA/CJ;AAkDE;EACE,yCAAA;AAhDJ;AAkDI;EACE,yBAAA;AAhDN;AAoDE;EACE,yBAAA;EACA,kCAAA;AAlDJ;AAqDE;EACE,8BAAA;EACA,yBAAA;EACA,yCAAA;AAnDJ;AAsDE;EACE,8BAAA;AApDJ;AAwDE;;EAEE,8BAAA;EACA,yBAAA;AAtDJ;AAyDE;EACE,8BAAA;EACA,wDAAA;AAvDJ;AA0DE;;EAEE,yBAAA;AAxDJ;AA2DE;EACE,yBAAA;AAzDJ;AA4DE;EACE,8BAAA;EACA,iDAAA;AA1DJ;AA6DE;;EAEE,yBAAA;AA3DJ;AA8DE;EACE,8BAAA;AA5DJ;AA+DE;EACE,yFAAA;AA7DJ;AA+DI;EACE,0CAAA;AA7DN;AAiEE;EACE,yBAAA;EACA,kCAAA;AA/DJ;AAiEI;EACE,gDAAA;EACA,yBAAA;AA/DN;AAmEE;;EAEE,yBAAA;AAjEJ;AAoEE;;EAEE,yBAAA;AAlEJ;AAqEE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAnEJ;AAqEI;EAA6B,yBAAA;AAlEjC;AAqEE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAnEJ;AAqEI;EAA6B,yBAAA;AAlEjC;AAqEE;EACE,8CAAA;EACA,yBAAA;EACA,kDAAA;AAnEJ;AAqEI;EAA6B,yBAAA;AAlEjC;AAqEE;EACE,6CAAA;EACA,yBAAA;EACA,kDAAA;AAnEJ;AAqEI;EAA6B,yBAAA;AAlEjC;AAsEE;;;;EAIE,8BAAA;EACA,iDAAA;EACA,yBAAA;AApEJ;AAuEE;EACE,yBAAA;AArEJ;AAuEI;EAA6B,yBAAA;AApEjC;AAuEE;EACE,yBAAA;AArEJ;AAuEI;EAAa,yBAAA;AApEjB;AAuEE;EACE,yBAAA;AArEJ;AAwEE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AAtEJ","sourcesContent":["/* ================================================================\n   Collaboration Requests — full design system\n   Colours & spacing aligned with Flowchest's existing dashboard\n   ================================================================ */\n\n// Design tokens — align with Flowchest --fc-* theme vars\n$primary:   #5ea1d8;\n$primary-d: #4a8fc4;\n$approve:   #16a34a;\n$approve-bg:#dcfce7;\n$reject:    #dc2626;\n$reject-bg: #fee2e2;\n$withdraw:  #e65100;\n$withdraw-bg:#fff3e0;\n$pending-bg:#fef3c7;\n$pending-fg:#d97706;\n$approved-bg:#dcfce7;\n$approved-fg:#16a34a;\n$rejected-bg:#fee2e2;\n$rejected-fg:#dc2626;\n$withdrawn-bg:#f3e5f5;\n$withdrawn-fg:#7b1fa2;\n$surface:   var(--fc-bg2, #f8f9fa);\n$surface-lo:var(--fc-bg-head, #f3f4f5);\n$surface-0: var(--fc-bg, #ffffff);\n$border:    var(--fc-border, #e2e8f0);\n$text:      var(--fc-fg, #0f172a);\n$muted:     var(--fc-fg-muted, #94a3b8);\n$font:      \"Raleway\", \"Inter\", system-ui, sans-serif;\n\n// ── Shared utilities ────────────────────────────────────────────\n\n.cr-muted       { color: $muted; font-size: 0.8125rem; }\n.cr-fw6         { font-weight: 600; font-size: 0.9rem; }\n\n.material-symbols-outlined {\n  font-family: \"Material Symbols Outlined\", sans-serif !important;\n  font-weight: normal !important;\n  font-style: normal !important;\n  line-height: 1 !important;\n  letter-spacing: normal !important;\n  text-transform: none !important;\n  display: inline-block !important;\n  white-space: nowrap !important;\n  -webkit-font-smoothing: antialiased;\n  vertical-align: middle;\n}\n\n// ── Page wrapper ────────────────────────────────────────────────\n\n.cr-page {\n  font-family: $font;\n  color: $text;\n  padding: 1.5rem 1.75rem 5rem;\n  min-height: calc(100vh - 64px);\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n  background: transparent;\n\n  @media (max-width: 767px) {\n    padding: 1rem 1rem 4rem;\n  }\n}\n\n// ── Header ──────────────────────────────────────────────────────\n\n.cr-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.cr-header-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.cr-header-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 0.625rem;\n  background: rgba(94, 161, 216, 0.15);\n  color: $primary;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  .material-symbols-outlined { font-size: 1.5rem !important; }\n}\n\n.cr-title {\n  font-size: 1.75rem;\n  font-weight: 800;\n  margin: 0 0 0.2rem;\n  font-family: \"Manrope\", system-ui, sans-serif;\n}\n\n.cr-subtitle {\n  margin: 0;\n  font-size: 0.9rem;\n  color: $muted;\n}\n\n// ── Tabs ─────────────────────────────────────────────────────────\n\n.cr-tabs {\n  display: flex;\n  gap: 0.5rem;\n  border-bottom: 2px solid $border;\n  margin-bottom: 1.5rem;\n}\n\n.cr-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.75rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: $muted;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease;\n  font-family: $font;\n\n  .material-symbols-outlined { font-size: 1.125rem !important; }\n\n  &:hover { color: $primary; }\n\n  &--active {\n    color: $primary;\n    border-bottom-color: $primary;\n  }\n}\n\n.cr-tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: $primary;\n  color: #fff;\n  line-height: 1;\n\n  &--neutral { background: #9e9e9e; }\n}\n\n// ── Stats cards ──────────────────────────────────────────────────\n\n.cr-stats {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n\n  @media (min-width: 640px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.cr-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  background: $surface-0;\n  border-radius: 0.75rem;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  border: 1px solid $border;\n}\n\n:host-context(body.theme-dark) {\n  .cr-stat-card {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.22) !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-stat-value {\n    color: #f1f5f9 !important;\n  }\n\n  .cr-stat-label {\n    color: #94a3b8 !important;\n  }\n\n  .cr-stat-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.625rem;\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .cr-stat-icon--primary {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #7bbde8 !important;\n  }\n\n  .cr-stat-icon--pending {\n    background: rgba(253, 186, 116, 0.16) !important;\n    color: #fde68a !important;\n  }\n\n  .cr-stat-icon--approved {\n    background: rgba(134, 239, 172, 0.14) !important;\n    color: #86efac !important;\n  }\n\n  .cr-stat-icon--rejected {\n    background: rgba(252, 165, 165, 0.14) !important;\n    color: #fca5a5 !important;\n  }\n}\n\n.cr-stat-icon {\n  font-size: 1.625rem !important;\n  flex-shrink: 0;\n\n  &--primary  { color: $primary; }\n  &--pending  { color: $pending-fg; }\n  &--approved { color: $approve; }\n  &--rejected { color: $reject; }\n}\n\n.cr-stat-value {\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: 1;\n  font-family: \"Manrope\", system-ui, sans-serif;\n}\n\n.cr-stat-label {\n  font-size: 0.8125rem;\n  color: $muted;\n  margin-top: 2px;\n}\n\n// ── Toolbar ──────────────────────────────────────────────────────\n\n.cr-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.cr-search-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 220px;\n}\n\n.cr-search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: $muted;\n  font-size: 1.125rem !important;\n  pointer-events: none;\n}\n\n.cr-search {\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 0 0.875rem 0 2.5rem;\n  border: 1px solid $border;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-family: $font;\n  background: $surface-0;\n  color: $text;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n\n  &:focus {\n    outline: none;\n    border-color: $primary;\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n  }\n}\n\n.cr-filter-select {\n  padding: 0 0.875rem;\n  margin: 0;\n  box-sizing: border-box;\n  border: 1px solid $border;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-family: $font;\n  background: $surface-0;\n  color: $text;\n  cursor: pointer;\n  height: 40px;\n\n  &:focus { outline: none; border-color: $primary; }\n}\n\n.cr-view-toggle {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  border: 1px solid $border;\n  border-radius: 0.5rem;\n  background: $surface-0;\n  color: $muted;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n\n  .material-symbols-outlined { font-size: 1.125rem !important; }\n  &:hover { background: rgba(94, 161, 216, 0.08); color: $primary; }\n}\n\n// ── Request Cards grid (Flowchest modern card style) ──────────────\n\n.cr-cards-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media (min-width: 1280px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.cr-card {\n  background: $surface-0;\n  border: 1px solid $border;\n  border-radius: 16px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease, border-color 0.2s ease;\n  box-sizing: border-box;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n}\n\n.cr-card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 24px 24px 0;\n}\n\n.cr-card-who {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cr-card-name {\n  margin: 0;\n  font-weight: 700;\n  font-size: 16px;\n  color: $text;\n  font-family: $font;\n}\n\n.cr-card-email {\n  margin: 0;\n  font-size: 12px;\n  color: $muted;\n}\n\n.cr-card-username {\n  font-size: 12px;\n  color: $primary;\n}\n\n.cr-card-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n.cr-content-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n}\n\n.cr-content-type-icon {\n  color: $primary;\n  font-size: 1.25rem !important;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.cr-content-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cr-content-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: $muted;\n}\n\n.cr-content-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: $primary;\n  cursor: pointer;\n  text-align: left;\n  font-family: $font;\n  transition: color 0.15s, text-decoration 0.15s;\n  line-height: 1.5;\n\n  .material-symbols-outlined { font-size: 0.875rem !important; }\n  &:hover {\n    color: $primary-d;\n    text-decoration: underline;\n  }\n}\n\n.cr-role-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 14px;\n  color: $text;\n  font-weight: 500;\n\n  .material-symbols-outlined { color: $primary; font-size: 1rem !important; }\n  strong { color: $text; }\n}\n\n.cr-message, .cr-response {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  background: $surface;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 14px;\n  border-left: 3px solid transparent;\n\n  p {\n    margin: 0;\n    line-height: 1.6;\n    flex: 1;\n    color: $text;\n  }\n  .material-symbols-outlined {\n    font-size: 1rem !important;\n    flex-shrink: 0;\n    color: $muted;\n    margin-top: 1px;\n  }\n}\n\n.cr-response {\n  border-left-color: $primary;\n  .material-symbols-outlined { color: $primary; }\n}\n\n.cr-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding-top: 0.25rem;\n}\n\n.cr-date {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 12px;\n  color: $muted;\n\n  .material-symbols-outlined { font-size: 0.9rem !important; }\n  &--response { color: $approve; .material-symbols-outlined { color: $approve; } }\n}\n\n.cr-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 24px 24px;\n  border-top: 1px solid $border;\n  background: transparent;\n\n  .cr-btn {\n    flex: 1;\n    min-width: 0;\n    justify-content: center;\n  }\n}\n\n// ── Avatars ───────────────────────────────────────────────────────\n\n.cr-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  flex-shrink: 0;\n  color: #fff;\n  font-family: $font;\n\n  &--primary   { background: $primary; }\n  &--secondary { background: #1a6b3a; }\n  &--sm {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n}\n\n// ── Status badges ─────────────────────────────────────────────────\n\n.cr-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  font-family: $font;\n\n  .material-symbols-outlined { font-size: 14px !important; }\n\n  &--pending   { background: $pending-bg;   color: $pending-fg; }\n  &--approved  { background: $approved-bg;  color: $approved-fg; }\n  &--rejected  { background: $rejected-bg;  color: $rejected-fg; }\n  &--withdrawn { background: $withdrawn-bg; color: $withdrawn-fg; }\n}\n\n// ── Role pill ─────────────────────────────────────────────────────\n\n.cr-role-pill {\n  display: inline-block;\n  padding: 0.2rem 0.6rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: rgba(94, 161, 216, 0.12);\n  color: $primary;\n}\n\n// ── Buttons ───────────────────────────────────────────────────────\n\n.cr-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  font-family: $font;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  min-height: 40px;\n  text-transform: none;\n\n  .material-symbols-outlined { font-size: 18px !important; }\n\n  &:disabled { opacity: 0.55; cursor: not-allowed; transform: none !important; box-shadow: none !important; }\n\n  &--primary {\n    background: $primary;\n    color: #fff;\n    border-color: $primary;\n    &:hover:not(:disabled) {\n      background: $primary-d;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3);\n    }\n  }\n\n  &--ghost {\n    background: transparent;\n    color: $text;\n    border-color: $border;\n    &:hover:not(:disabled) {\n      background: $surface;\n      border-color: rgba(94, 161, 216, 0.4);\n      color: $primary;\n    }\n  }\n\n  &--approve {\n    background: $approve-bg;\n    color: $approve;\n    border-color: #bbf7d0;\n    &:hover:not(:disabled) {\n      background: darken(#dcfce7, 4%);\n      transform: translateY(-1px);\n    }\n  }\n\n  &--reject {\n    background: $reject-bg;\n    color: $reject;\n    border-color: #fecaca;\n    &:hover:not(:disabled) {\n      background: darken(#fee2e2, 3%);\n      transform: translateY(-1px);\n    }\n  }\n\n  &--withdraw {\n    background: $withdraw-bg;\n    color: $withdraw;\n    border-color: #fed7aa;\n    &:hover:not(:disabled) {\n      background: darken(#fff3e0, 4%);\n      transform: translateY(-1px);\n    }\n  }\n}\n\n// ── Table ─────────────────────────────────────────────────────────\n\n.cr-table-wrap {\n  overflow-x: auto;\n  border: 1px solid $border;\n  border-radius: 0.75rem;\n  background: $surface-0;\n}\n\n.cr-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n\n  th, td {\n    padding: 0.875rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid $border;\n  }\n\n  th {\n    background: $surface;\n    font-weight: 700;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $muted;\n  }\n\n  tr:last-child td { border-bottom: none; }\n  tr:not(:last-child):hover td { background: $surface; }\n}\n\n.cr-table-person {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n}\n\n.cr-table-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: $primary;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-family: $font;\n  text-align: left;\n  &:hover { text-decoration: underline; }\n}\n\n.cr-table-message {\n  max-width: 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cr-table-empty {\n  text-align: center;\n  color: $muted;\n  padding: 2.5rem !important;\n}\n\n.cr-table-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.cr-icon-btn {\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  color: $primary;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n\n  .material-symbols-outlined { font-size: 1.1rem !important; }\n\n  &:hover { background: rgba(94, 161, 216, 0.1); }\n  &--approve { color: $approve; &:hover { background: $approve-bg; } }\n  &--reject  { color: $reject;  &:hover { background: $reject-bg; } }\n  &--withdraw{ color: $withdraw;&:hover { background: $withdraw-bg; } }\n}\n\n// ── Empty state ───────────────────────────────────────────────────\n\n.cr-empty {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3.5rem 1.5rem;\n  text-align: center;\n\n  h3 { margin: 0.75rem 0 0.375rem; font-size: 1.125rem; font-weight: 700; }\n  p  { margin: 0; color: $muted; font-size: 0.9rem; }\n}\n\n.cr-empty-icon {\n  font-size: 3.5rem !important;\n  color: #c0c7d0;\n}\n\n// ── Preview panel (Flowchest right drawer) ────────────────────────\n\n.cr-preview-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  background: rgba(0, 0, 0, 0);\n  transition: background 0.25s ease;\n  pointer-events: none;\n\n  &--open {\n    background: rgba(15, 23, 42, 0.45);\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n    pointer-events: all;\n  }\n}\n\n.cr-preview-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(440px, 100vw);\n  background: $surface-0;\n  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1101;\n  border-left: 1px solid $border;\n\n  &--open { transform: translateX(0); }\n}\n\n.cr-preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.125rem 1.5rem;\n  border-bottom: 1px solid $border;\n  flex-shrink: 0;\n  background: $surface-0;\n}\n\n.cr-preview-head-left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.cr-preview-head-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  background: rgba(94, 161, 216, 0.14);\n  color: $primary !important;\n  font-size: 1.25rem !important;\n}\n\n.cr-preview-head-label {\n  font-weight: 700;\n  font-size: 1rem;\n  color: $text;\n  font-family: $font;\n}\n\n.cr-preview-close {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid $border;\n  background: $surface;\n  border-radius: 10px;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: $muted;\n  line-height: 1;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.1);\n    color: $primary;\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n}\n\n.cr-preview-thumb-wrap {\n  flex-shrink: 0;\n  height: 160px;\n  background: $surface;\n  overflow: hidden;\n  border-bottom: 1px solid $border;\n}\n\n.cr-preview-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.cr-preview-thumb-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, rgba(94, 161, 216, 0.18) 0%, rgba(94, 161, 216, 0.05) 55%, $surface 100%);\n\n  .material-symbols-outlined {\n    font-size: 3.25rem !important;\n    color: rgba(94, 161, 216, 0.55);\n  }\n}\n\n.cr-preview-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  background: $surface-0;\n}\n\n.cr-preview-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n  font-family: $font;\n  color: $text;\n  line-height: 1.35;\n}\n\n.cr-preview-description {\n  margin: 0;\n  color: $muted;\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.cr-preview-section {\n  background: $surface;\n  border: 1px solid $border;\n  border-radius: 14px;\n  padding: 1.125rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.cr-preview-section-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: $muted;\n  font-family: $font;\n}\n\n.cr-preview-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cr-preview-field-label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: $muted;\n}\n\n.cr-preview-person {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cr-preview-message,\n.cr-preview-response {\n  margin: 0;\n  padding: 12px;\n  border-radius: 8px;\n  background: $surface-0;\n  border: 1px solid $border;\n  color: $text;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.cr-preview-response {\n  border-left: 3px solid $primary;\n}\n\n.cr-preview-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 0.5rem;\n  position: sticky;\n  bottom: 0;\n  background: linear-gradient(to top, $surface-0 70%, transparent);\n\n  .cr-btn {\n    width: 100%;\n    justify-content: center;\n    border-radius: 10px;\n    min-height: 42px;\n  }\n}\n\n// ── Action dialog ─────────────────────────────────────────────────\n\n.cr-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.cr-dialog {\n  width: 100%;\n  max-width: 480px;\n  background: $surface-0;\n  border-radius: 16px;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.2);\n  border: 1px solid $border;\n  overflow: hidden;\n}\n\n.cr-dialog-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.125rem 1.5rem;\n  border-bottom: 1px solid $border;\n  background: $surface-0;\n\n  h4 {\n    margin: 0;\n    font-size: 1.0625rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 0.625rem;\n    color: $text;\n    font-family: $font;\n\n    .material-symbols-outlined {\n      font-size: 1.35rem !important;\n      color: $primary;\n    }\n  }\n}\n\n.cr-dialog-body {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: $surface-0;\n}\n\n.cr-dialog-desc {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: $muted;\n\n  strong, em {\n    color: $text;\n  }\n}\n\n.cr-dialog-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.cr-dialog-label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: $muted;\n}\n\n.cr-dialog-textarea {\n  width: 100%;\n  padding: 0.75rem 0.875rem;\n  border: 1px solid $border;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  font-family: $font;\n  resize: vertical;\n  box-sizing: border-box;\n  background: $surface;\n  color: $text;\n\n  &:focus {\n    outline: none;\n    border-color: $primary;\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n    background: $surface-0;\n  }\n}\n\n.cr-dialog-foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem 1.5rem;\n  border-top: 1px solid $border;\n  background: $surface-0;\n}\n\n// ── Skeleton ──────────────────────────────────────────────────────\n\n@keyframes cr-shimmer {\n  0%   { background-position: -400px 0; }\n  100% { background-position: 400px 0; }\n}\n\n%skeleton-anim {\n  background: linear-gradient(90deg, #f3f4f5 25%, #e8e9ea 50%, #f3f4f5 75%);\n  background-size: 400px 100%;\n  animation: cr-shimmer 1.4s linear infinite;\n  border-radius: 0.375rem;\n}\n\n.cr-skeleton {\n  pointer-events: none;\n}\n\n.cr-skel-avatar {\n  @extend %skeleton-anim;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.cr-skel-icon {\n  @extend %skeleton-anim;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.375rem;\n  flex-shrink: 0;\n}\n\n.cr-skel-text-wrap {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cr-skel-line {\n  @extend %skeleton-anim;\n  height: 14px;\n  width: 70%;\n\n  &--lg { width: 90%; height: 20px; }\n  &--sm { width: 50%; height: 11px; }\n}\n\n.cr-skel-block {\n  @extend %skeleton-anim;\n  height: 56px;\n  width: 100%;\n  margin: 0 1rem;\n  border-radius: 0.5rem;\n\n  &--sm { height: 36px; }\n}\n\n// ── Dark mode ─────────────────────────────────────────────────────\n\nbody.theme-dark .cr-page {\n  background: transparent;\n  color: #e5e7eb;\n}\n\nbody.theme-dark .cr-title {\n  color: #f1f5f9 !important;\n}\n\nbody.theme-dark .cr-subtitle,\nbody.theme-dark .cr-muted,\nbody.theme-dark .cr-stat-label,\nbody.theme-dark .cr-card-email,\nbody.theme-dark .cr-content-label,\nbody.theme-dark .cr-date,\nbody.theme-dark .cr-empty p,\nbody.theme-dark .cr-dialog-desc,\nbody.theme-dark .cr-table-empty {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-stat-value,\nbody.theme-dark .cr-card-name,\nbody.theme-dark .cr-fw6,\nbody.theme-dark .cr-empty h3,\nbody.theme-dark .cr-preview-title,\nbody.theme-dark .cr-dialog-label {\n  color: #e5e7eb !important;\n}\n\n/* Stat / number cards — solid dark panels (match dashboard cards) */\nbody.theme-dark .cr-stat-card {\n  background: #111827 !important;\n  background-color: #111827 !important;\n  border: 1px solid rgba(148, 163, 184, 0.22) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .cr-stat-value {\n  color: #f1f5f9 !important;\n}\n\nbody.theme-dark .cr-stat-label {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-stat-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.625rem;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.theme-dark .cr-stat-icon--primary {\n  background: rgba(94, 161, 216, 0.18) !important;\n  color: #7bbde8 !important;\n}\n\nbody.theme-dark .cr-stat-icon--pending {\n  background: rgba(253, 186, 116, 0.16) !important;\n  color: #fde68a !important;\n}\n\nbody.theme-dark .cr-stat-icon--approved {\n  background: rgba(134, 239, 172, 0.14) !important;\n  color: #86efac !important;\n}\n\nbody.theme-dark .cr-stat-icon--rejected {\n  background: rgba(252, 165, 165, 0.14) !important;\n  color: #fca5a5 !important;\n}\n\nbody.theme-dark .cr-card,\nbody.theme-dark .cr-table-wrap,\nbody.theme-dark .cr-preview-panel,\nbody.theme-dark .cr-dialog {\n  background: var(--fc-bg, #111827) !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.25)) !important;\n  color: var(--fc-fg, #e5e7eb) !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35) !important;\n}\n\nbody.theme-dark .cr-card:hover {\n  border-color: rgba(94, 161, 216, 0.4) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45) !important;\n}\n\nbody.theme-dark .cr-card-actions {\n  background: transparent !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;\n}\n\nbody.theme-dark .cr-preview-section,\nbody.theme-dark .cr-message,\nbody.theme-dark .cr-response {\n  background: var(--fc-bg2, #1f2937) !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;\n}\n\nbody.theme-dark .cr-preview-head,\nbody.theme-dark .cr-preview-body,\nbody.theme-dark .cr-preview-actions {\n  background: var(--fc-bg, #111827) !important;\n}\n\nbody.theme-dark .cr-preview-thumb-wrap {\n  background: var(--fc-bg2, #1f2937) !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;\n}\n\nbody.theme-dark .cr-preview-thumb-placeholder {\n  background: linear-gradient(\n    145deg,\n    rgba(94, 161, 216, 0.22) 0%,\n    rgba(94, 161, 216, 0.08) 55%,\n    #1f2937 100%\n  ) !important;\n}\n\nbody.theme-dark .cr-preview-message,\nbody.theme-dark .cr-preview-response {\n  background: var(--fc-bg-head, #0f172a) !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.2)) !important;\n  color: var(--fc-fg, #e5e7eb) !important;\n}\n\nbody.theme-dark .cr-preview-close {\n  background: var(--fc-bg2, #1f2937) !important;\n  border-color: var(--fc-border, rgba(148, 163, 184, 0.3)) !important;\n  color: var(--fc-fg-muted, #94a3b8) !important;\n\n  &:hover {\n    background: rgba(94, 161, 216, 0.15) !important;\n    color: #7bbde8 !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n  }\n}\n\nbody.theme-dark .cr-preview-backdrop--open {\n  background: rgba(0, 0, 0, 0.55) !important;\n}\n\nbody.theme-dark .cr-card-actions,\nbody.theme-dark .cr-preview-section,\nbody.theme-dark .cr-message,\nbody.theme-dark .cr-response {\n  border-color: rgba(148, 163, 184, 0.15) !important;\n}\n\nbody.theme-dark .cr-message p,\nbody.theme-dark .cr-response p,\nbody.theme-dark .cr-role-row,\nbody.theme-dark .cr-role-row strong,\nbody.theme-dark .cr-table td {\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .cr-message .material-symbols-outlined {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-search,\nbody.theme-dark .cr-filter-select,\nbody.theme-dark .cr-dialog-textarea {\n  background: #0f172a !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .cr-search-icon {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-filter-select option {\n  background: #0f172a;\n  color: #e5e7eb;\n}\n\n/* Tabs — underline only, no box/border wrapper */\nbody.theme-dark .cr-tabs {\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 2px solid rgba(148, 163, 184, 0.15) !important;\n}\n\nbody.theme-dark .cr-tab {\n  color: #94a3b8 !important;\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 3px solid transparent !important;\n\n  .material-symbols-outlined {\n    color: inherit !important;\n  }\n\n  &:hover {\n    color: #cbd5e1 !important;\n  }\n\n  &--active {\n    color: #5ea1d8 !important;\n    background: transparent !important;\n    border-bottom-color: #5ea1d8 !important;\n    box-shadow: none !important;\n  }\n}\n\nbody.theme-dark .cr-tab-badge {\n  background: #5ea1d8 !important;\n  color: #ffffff !important;\n\n  &--neutral {\n    background: #64748b !important;\n    color: #ffffff !important;\n  }\n}\n\n/* Card/table toggle — icon only, no box */\nbody.theme-dark .cr-view-toggle {\n  background: transparent !important;\n  border: none !important;\n  color: #5ea1d8 !important;\n\n  .material-symbols-outlined {\n    color: #5ea1d8 !important;\n  }\n\n  &:hover {\n    background: transparent !important;\n    color: #7bbde8 !important;\n\n    .material-symbols-outlined {\n      color: #7bbde8 !important;\n    }\n  }\n}\n\n/* Status badges */\nbody.theme-dark .cr-status {\n  &--pending {\n    background: #78350f !important;\n    color: #fde68a !important;\n  }\n\n  &--approved {\n    background: #14532d !important;\n    color: #d1fae5 !important;\n  }\n\n  &--rejected {\n    background: #7f1d1d !important;\n    color: #fecaca !important;\n  }\n\n  &--withdrawn {\n    background: #581c87 !important;\n    color: #e9d5ff !important;\n  }\n}\n\n/* Action buttons */\nbody.theme-dark .cr-btn {\n  &--ghost {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #e5e7eb !important;\n    }\n  }\n\n  &--approve {\n    background: rgba(46, 125, 50, 0.22) !important;\n    color: #86efac !important;\n    border-color: rgba(134, 239, 172, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #86efac !important;\n    }\n  }\n\n  &--reject {\n    background: rgba(198, 40, 40, 0.22) !important;\n    color: #fca5a5 !important;\n    border-color: rgba(252, 165, 165, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #fca5a5 !important;\n    }\n  }\n\n  &--withdraw {\n    background: rgba(230, 81, 0, 0.22) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #fdba74 !important;\n    }\n  }\n\n  &--primary {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n  }\n}\n\nbody.theme-dark .cr-content-title,\nbody.theme-dark .cr-table-link,\nbody.theme-dark .cr-icon-btn {\n  color: #5ea1d8 !important;\n\n  .material-symbols-outlined {\n    color: #5ea1d8 !important;\n  }\n}\n\nbody.theme-dark .cr-icon-btn {\n  &--approve { color: #86efac !important; }\n  &--reject  { color: #fca5a5 !important; }\n  &--withdraw { color: #fdba74 !important; }\n}\n\nbody.theme-dark .cr-content-type-icon,\nbody.theme-dark .cr-role-row .material-symbols-outlined,\nbody.theme-dark .cr-stat-icon--primary {\n  color: #7bbde8 !important;\n}\n\nbody.theme-dark .cr-stat-icon--pending { color: #fde68a !important; }\nbody.theme-dark .cr-stat-icon--approved { color: #86efac !important; }\nbody.theme-dark .cr-stat-icon--rejected { color: #fca5a5 !important; }\n\nbody.theme-dark .cr-date--response,\nbody.theme-dark .cr-date--response .material-symbols-outlined {\n  color: #86efac !important;\n}\n\nbody.theme-dark .cr-response {\n  border-left-color: #5ea1d8 !important;\n\n  p { color: #e5e7eb !important; }\n  .material-symbols-outlined { color: #5ea1d8 !important; }\n}\n\nbody.theme-dark .cr-preview-field-label {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-preview-message {\n  color: #e5e7eb !important;\n}\n\nbody.theme-dark .cr-preview-response {\n  background: #111827 !important;\n  color: #86efac !important;\n  border-left: 3px solid #5ea1d8 !important;\n}\n\nbody.theme-dark .cr-role-pill {\n  background: rgba(94, 161, 216, 0.18) !important;\n  color: #7bbde8 !important;\n}\n\nbody.theme-dark .cr-empty-icon {\n  color: #475569 !important;\n}\n\nbody.theme-dark .cr-preview-close {\n  color: #94a3b8 !important;\n\n  &:hover {\n    background: rgba(148, 163, 184, 0.12) !important;\n    color: #e5e7eb !important;\n  }\n}\n\nbody.theme-dark .cr-table th {\n  background: #111827 !important;\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .cr-table td {\n  border-color: rgba(148, 163, 184, 0.15) !important;\n}\n\nbody.theme-dark .cr-table tr:not(:last-child):hover td {\n  background: #111827 !important;\n}\n\nbody.theme-dark .cr-preview-head,\nbody.theme-dark .cr-dialog-head,\nbody.theme-dark .cr-dialog-foot,\nbody.theme-dark .cr-dialog-body {\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  background: #1f2937 !important;\n}\n\nbody.theme-dark .cr-preview-thumb-wrap {\n  background: #0f172a !important;\n}\n\nbody.theme-dark .cr-header-icon {\n  background: rgba(94, 161, 216, 0.18) !important;\n  color: #5ea1d8 !important;\n}\n\n/* Maximum specificity — override global app-main-content button/span rules */\nbody.theme-dark .app-main-content app-collaboration-requests {\n  button.cr-btn.cr-btn--ghost,\n  .cr-btn.cr-btn--ghost {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #e5e7eb !important;\n    }\n  }\n\n  button.cr-btn.cr-btn--withdraw,\n  .cr-btn.cr-btn--withdraw {\n    background: rgba(230, 81, 0, 0.28) !important;\n    background-color: rgba(230, 81, 0, 0.28) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.4) !important;\n\n    .material-symbols-outlined {\n      color: #fdba74 !important;\n    }\n  }\n\n  span.cr-status.cr-status--pending,\n  .cr-status.cr-status--pending {\n    background: #78350f !important;\n    background-color: #78350f !important;\n    color: #fde68a !important;\n\n    .material-symbols-outlined {\n      color: #fde68a !important;\n    }\n  }\n\n  span.cr-status.cr-status--approved,\n  .cr-status.cr-status--approved {\n    background: #14532d !important;\n    background-color: #14532d !important;\n    color: #d1fae5 !important;\n\n    .material-symbols-outlined {\n      color: #d1fae5 !important;\n    }\n  }\n\n  span.cr-status.cr-status--rejected,\n  .cr-status.cr-status--rejected {\n    background: #7f1d1d !important;\n    background-color: #7f1d1d !important;\n    color: #fecaca !important;\n\n    .material-symbols-outlined {\n      color: #fecaca !important;\n    }\n  }\n\n  span.cr-status.cr-status--withdrawn,\n  .cr-status.cr-status--withdrawn {\n    background: #581c87 !important;\n    background-color: #581c87 !important;\n    color: #e9d5ff !important;\n\n    .material-symbols-outlined {\n      color: #e9d5ff !important;\n    }\n  }\n}\n\n/* Beat global app-main-content button/text overrides (white text on white/light bg) */\nbody.theme-dark app-collaboration-requests {\n  .cr-stat-card {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.22) !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-stat-value {\n    color: #f1f5f9 !important;\n  }\n\n  .cr-stat-label {\n    color: #94a3b8 !important;\n  }\n\n  .cr-stat-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.625rem;\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .cr-stat-icon--primary {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #7bbde8 !important;\n  }\n\n  .cr-stat-icon--pending {\n    background: rgba(253, 186, 116, 0.16) !important;\n    color: #fde68a !important;\n  }\n\n  .cr-stat-icon--approved {\n    background: rgba(134, 239, 172, 0.14) !important;\n    color: #86efac !important;\n  }\n\n  .cr-stat-icon--rejected {\n    background: rgba(252, 165, 165, 0.14) !important;\n    color: #fca5a5 !important;\n  }\n\n  .cr-card {\n    background: var(--fc-bg, #111827) !important;\n    background-color: var(--fc-bg, #111827) !important;\n    border-color: var(--fc-border, rgba(148, 163, 184, 0.25)) !important;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35) !important;\n  }\n\n  .cr-btn.cr-btn--ghost,\n  .cr-btn--ghost,\n  .cr-card-actions .cr-btn.cr-btn--ghost,\n  .cr-dialog-foot .cr-btn.cr-btn--ghost,\n  .cr-preview-actions .cr-btn.cr-btn--ghost {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover:not(:disabled) {\n      background: #374151 !important;\n      background-color: #374151 !important;\n      color: #f1f5f9 !important;\n    }\n\n    .material-symbols-outlined {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-btn.cr-btn--withdraw,\n  .cr-btn--withdraw,\n  .cr-card-actions .cr-btn.cr-btn--withdraw {\n    background: rgba(230, 81, 0, 0.28) !important;\n    background-color: rgba(230, 81, 0, 0.28) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.4) !important;\n\n    &:hover:not(:disabled) {\n      background: rgba(230, 81, 0, 0.4) !important;\n      background-color: rgba(230, 81, 0, 0.4) !important;\n      color: #fed7aa !important;\n    }\n\n    .material-symbols-outlined {\n      color: #fdba74 !important;\n    }\n  }\n\n  /* Status badges — cards, table, preview (beat global span color override) */\n  .cr-status.cr-status--pending,\n  span.cr-status.cr-status--pending {\n    background: #78350f !important;\n    background-color: #78350f !important;\n    color: #fde68a !important;\n\n    .material-symbols-outlined {\n      color: #fde68a !important;\n    }\n  }\n\n  .cr-status.cr-status--approved,\n  span.cr-status.cr-status--approved {\n    background: #14532d !important;\n    background-color: #14532d !important;\n    color: #d1fae5 !important;\n\n    .material-symbols-outlined {\n      color: #d1fae5 !important;\n    }\n  }\n\n  .cr-status.cr-status--rejected,\n  span.cr-status.cr-status--rejected {\n    background: #7f1d1d !important;\n    background-color: #7f1d1d !important;\n    color: #fecaca !important;\n\n    .material-symbols-outlined {\n      color: #fecaca !important;\n    }\n  }\n\n  .cr-status.cr-status--withdrawn,\n  span.cr-status.cr-status--withdrawn {\n    background: #581c87 !important;\n    background-color: #581c87 !important;\n    color: #e9d5ff !important;\n\n    .material-symbols-outlined {\n      color: #e9d5ff !important;\n    }\n  }\n\n  .cr-message,\n  .cr-response {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.12) !important;\n\n    p {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-message .material-symbols-outlined {\n    color: #94a3b8 !important;\n  }\n\n  .cr-response {\n    border-left: 3px solid #5ea1d8 !important;\n    border-top: none !important;\n    border-right: none !important;\n    border-bottom: none !important;\n\n    .material-symbols-outlined {\n      color: #5ea1d8 !important;\n    }\n  }\n\n  .cr-preview-message {\n    color: #e5e7eb !important;\n    background: transparent !important;\n  }\n\n  .cr-preview-response {\n    background: #111827 !important;\n    color: #86efac !important;\n    border-left: 3px solid #5ea1d8 !important;\n  }\n\n  .cr-card-actions {\n    background: #111827 !important;\n  }\n\n  /* Preview slide-in panel */\n  .cr-preview-panel {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.45) !important;\n  }\n\n  .cr-preview-body {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-preview-head {\n    background: #1f2937 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .cr-preview-head-label {\n    color: #f1f5f9 !important;\n  }\n\n  .cr-preview-head-icon {\n    color: #5ea1d8 !important;\n  }\n\n  .cr-preview-title {\n    color: #f1f5f9 !important;\n  }\n\n  .cr-preview-section {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .cr-preview-section-title,\n  .cr-preview-field-label {\n    color: #94a3b8 !important;\n  }\n\n  .cr-preview-thumb-wrap {\n    background: #0f172a !important;\n  }\n\n  .cr-preview-thumb-placeholder {\n    background: linear-gradient(135deg, rgba(94, 161, 216, 0.14) 0%, #0f172a 100%) !important;\n\n    .material-symbols-outlined {\n      color: rgba(94, 161, 216, 0.55) !important;\n    }\n  }\n\n  .cr-preview-close {\n    color: #94a3b8 !important;\n    background: transparent !important;\n\n    &:hover {\n      background: rgba(148, 163, 184, 0.12) !important;\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-preview-person .cr-fw6,\n  .cr-preview-field .cr-fw6 {\n    color: #e5e7eb !important;\n  }\n\n  .cr-preview-person .cr-muted,\n  .cr-preview-field .cr-muted {\n    color: #94a3b8 !important;\n  }\n\n  .cr-preview-actions .cr-btn--primary {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n\n    .material-symbols-outlined {\n      color: #ffffff !important;\n    }\n  }\n\n  .cr-preview-actions .cr-btn--approve {\n    background: rgba(46, 125, 50, 0.22) !important;\n    color: #86efac !important;\n    border-color: rgba(134, 239, 172, 0.35) !important;\n\n    .material-symbols-outlined { color: #86efac !important; }\n  }\n\n  .cr-preview-actions .cr-btn--reject {\n    background: rgba(198, 40, 40, 0.22) !important;\n    color: #fca5a5 !important;\n    border-color: rgba(252, 165, 165, 0.35) !important;\n\n    .material-symbols-outlined { color: #fca5a5 !important; }\n  }\n\n  .cr-preview-actions .cr-btn--withdraw {\n    background: rgba(230, 81, 0, 0.22) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.35) !important;\n\n    .material-symbols-outlined { color: #fdba74 !important; }\n  }\n\n  /* Action confirmation dialog */\n  .cr-dialog {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-dialog-head,\n  .cr-dialog-body,\n  .cr-dialog-foot {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .cr-dialog-head h4 {\n    color: #f1f5f9 !important;\n\n    .material-symbols-outlined {\n      color: inherit !important;\n    }\n  }\n\n  .cr-dialog-desc {\n    color: #94a3b8 !important;\n\n    strong,\n    em {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-dialog-label {\n    color: #e5e7eb !important;\n  }\n\n  .cr-dialog-textarea {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-dialog-foot .cr-btn--ghost {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    .material-symbols-outlined {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-preview-section .cr-role-pill {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #7bbde8 !important;\n  }\n}\n\n// ── Responsive ────────────────────────────────────────────────────\n\n@media (max-width: 639px) {\n  .cr-page { padding: 0.5rem 0.75rem 4rem; }\n  .cr-title { font-size: 1.375rem; }\n  .cr-card-actions { flex-direction: column; .cr-btn { width: 100%; justify-content: center; } }\n  .cr-preview-panel { width: 100vw; }\n\n  /* Dark mode mobile: underline tabs, no box wrapper */\n  body.theme-dark .cr-tabs {\n    background: transparent !important;\n    border: none !important;\n    border-bottom: 2px solid rgba(148, 163, 184, 0.15) !important;\n    padding: 0;\n    border-radius: 0;\n    gap: 0;\n  }\n\n  body.theme-dark .cr-tab {\n    flex: 1;\n    justify-content: center;\n    margin-bottom: -2px;\n    padding: 0.625rem 0.5rem;\n    font-size: 0.8125rem;\n    border-radius: 0;\n    background: transparent !important;\n    border-bottom: 3px solid transparent !important;\n\n    &--active {\n      color: #5ea1d8 !important;\n      background: transparent !important;\n      border-bottom-color: #5ea1d8 !important;\n      box-shadow: none !important;\n\n      .material-symbols-outlined {\n        color: #5ea1d8 !important;\n      }\n    }\n  }\n\n  body.theme-dark .cr-view-toggle {\n    flex-shrink: 0;\n    background: transparent !important;\n    border: none !important;\n\n    .material-symbols-outlined {\n      color: #5ea1d8 !important;\n    }\n  }\n}\n\n/* Reinforce dark-mode via host context (Angular encapsulation) */\n:host-context(body.theme-dark) {\n  .cr-tab {\n    background: transparent !important;\n  }\n\n  .cr-tab--active {\n    color: #5ea1d8 !important;\n    background: transparent !important;\n    border-bottom-color: #5ea1d8 !important;\n    box-shadow: none !important;\n  }\n\n  .cr-view-toggle {\n    background: transparent !important;\n    border: none !important;\n    color: #5ea1d8 !important;\n  }\n\n  .cr-view-toggle .material-symbols-outlined {\n    color: #5ea1d8 !important;\n  }\n\n  .cr-view-toggle:hover,\n  .cr-view-toggle:hover .material-symbols-outlined {\n    color: #7bbde8 !important;\n  }\n\n  .cr-btn--ghost,\n  .cr-btn.cr-btn--ghost,\n  .cr-card-actions .cr-btn.cr-btn--ghost,\n  .cr-dialog-foot .cr-btn.cr-btn--ghost {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover:not(:disabled) {\n      background: #374151 !important;\n      background-color: #374151 !important;\n      color: #f1f5f9 !important;\n    }\n\n    .material-symbols-outlined {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-btn.cr-btn--withdraw,\n  .cr-btn--withdraw {\n    background: rgba(230, 81, 0, 0.28) !important;\n    background-color: rgba(230, 81, 0, 0.28) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.4) !important;\n\n    .material-symbols-outlined {\n      color: #fdba74 !important;\n    }\n  }\n\n  .cr-status.cr-status--pending,\n  span.cr-status.cr-status--pending {\n    background: #78350f !important;\n    background-color: #78350f !important;\n    color: #fde68a !important;\n\n    .material-symbols-outlined { color: #fde68a !important; }\n  }\n\n  .cr-status.cr-status--approved,\n  span.cr-status.cr-status--approved {\n    background: #14532d !important;\n    background-color: #14532d !important;\n    color: #d1fae5 !important;\n\n    .material-symbols-outlined { color: #d1fae5 !important; }\n  }\n\n  .cr-status.cr-status--rejected,\n  span.cr-status.cr-status--rejected {\n    background: #7f1d1d !important;\n    background-color: #7f1d1d !important;\n    color: #fecaca !important;\n\n    .material-symbols-outlined { color: #fecaca !important; }\n  }\n\n  .cr-status.cr-status--withdrawn,\n  span.cr-status.cr-status--withdrawn {\n    background: #581c87 !important;\n    background-color: #581c87 !important;\n    color: #e9d5ff !important;\n\n    .material-symbols-outlined { color: #e9d5ff !important; }\n  }\n\n  .cr-message,\n  .cr-response {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.12) !important;\n  }\n\n  .cr-message p,\n  .cr-response p {\n    color: #e5e7eb !important;\n  }\n\n  .cr-message .material-symbols-outlined {\n    color: #94a3b8 !important;\n  }\n\n  .cr-response {\n    border-left: 3px solid #5ea1d8 !important;\n\n    .material-symbols-outlined {\n      color: #5ea1d8 !important;\n    }\n  }\n\n  .cr-preview-message {\n    color: #e5e7eb !important;\n    background: transparent !important;\n  }\n\n  .cr-preview-response {\n    background: #111827 !important;\n    color: #86efac !important;\n    border-left: 3px solid #5ea1d8 !important;\n  }\n\n  .cr-card-actions {\n    background: #111827 !important;\n  }\n\n  /* Preview slide-in panel */\n  .cr-preview-panel,\n  .cr-preview-body {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-preview-head {\n    background: #1f2937 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .cr-preview-head-label,\n  .cr-preview-title {\n    color: #f1f5f9 !important;\n  }\n\n  .cr-preview-head-icon {\n    color: #5ea1d8 !important;\n  }\n\n  .cr-preview-section {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .cr-preview-section-title,\n  .cr-preview-field-label {\n    color: #94a3b8 !important;\n  }\n\n  .cr-preview-thumb-wrap {\n    background: #0f172a !important;\n  }\n\n  .cr-preview-thumb-placeholder {\n    background: linear-gradient(135deg, rgba(94, 161, 216, 0.14) 0%, #0f172a 100%) !important;\n\n    .material-symbols-outlined {\n      color: rgba(94, 161, 216, 0.55) !important;\n    }\n  }\n\n  .cr-preview-close {\n    color: #94a3b8 !important;\n    background: transparent !important;\n\n    &:hover {\n      background: rgba(148, 163, 184, 0.12) !important;\n      color: #e5e7eb !important;\n    }\n  }\n\n  .cr-preview-person .cr-fw6,\n  .cr-preview-field .cr-fw6 {\n    color: #e5e7eb !important;\n  }\n\n  .cr-preview-person .cr-muted,\n  .cr-preview-field .cr-muted {\n    color: #94a3b8 !important;\n  }\n\n  .cr-preview-actions .cr-btn--primary {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n\n    .material-symbols-outlined { color: #ffffff !important; }\n  }\n\n  .cr-preview-actions .cr-btn--approve {\n    background: rgba(46, 125, 50, 0.22) !important;\n    color: #86efac !important;\n    border-color: rgba(134, 239, 172, 0.35) !important;\n\n    .material-symbols-outlined { color: #86efac !important; }\n  }\n\n  .cr-preview-actions .cr-btn--reject {\n    background: rgba(198, 40, 40, 0.22) !important;\n    color: #fca5a5 !important;\n    border-color: rgba(252, 165, 165, 0.35) !important;\n\n    .material-symbols-outlined { color: #fca5a5 !important; }\n  }\n\n  .cr-preview-actions .cr-btn--withdraw {\n    background: rgba(230, 81, 0, 0.22) !important;\n    color: #fdba74 !important;\n    border-color: rgba(253, 186, 116, 0.35) !important;\n\n    .material-symbols-outlined { color: #fdba74 !important; }\n  }\n\n  /* Action confirmation dialog */\n  .cr-dialog,\n  .cr-dialog-head,\n  .cr-dialog-body,\n  .cr-dialog-foot {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #e5e7eb !important;\n  }\n\n  .cr-dialog-head h4 {\n    color: #f1f5f9 !important;\n\n    .material-symbols-outlined { color: inherit !important; }\n  }\n\n  .cr-dialog-desc {\n    color: #94a3b8 !important;\n\n    strong, em { color: #e5e7eb !important; }\n  }\n\n  .cr-dialog-label {\n    color: #e5e7eb !important;\n  }\n\n  .cr-dialog-textarea {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    color: #e5e7eb !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
